// Author      : Sculpteo
// Contributor : Dimitri Sabadie <dimitri.sabadie@sculpteo.com>
// Copyright   : (C) Sculpteo 2015
//
// This module exports the 3D viewer that can be embedded in HTML page through Javascript.

var Sculpteo3DViewerId = 0,
  Sculpteo3DViewerCap_static = 1,
  Sculpteo3DViewerCap_webgl = 8,
  Sculpteo3DViewerCaps = 0;

if (Sculpteo3DViewerRenderTimeout == null) {
  Sculpteo3DViewerRenderTimeout = "200,5000";
}

var Sculpteo3DViewerTech = "auto";

Sculpteo3DViewerTechInit = Sculpteo3DViewerTech;

$.fn.animatedPng = function (o) {
  return this.each(function () {
    var defaults = {
      nb_images: 19,
      image_width: 240,
      delay: 150,
    };
    var options = $.extend(defaults, o);
    var idx = 1;

    if ($(this).data("bg-idx")) {
      idx = $(this).data("bg-idx");
    } else {
      idx = 1;
    }

    if (idx == options.nb_images) {
      $(this).data("bg-idx", 1);
    } else {
      $(this).data("bg-idx", idx + 1);
    }

    $(this).css(
      "background-position",
      (idx - 1) * options.image_width + "px 0px"
    );
    $(this).delay(options.delay);
    $(this).queue(function () {
      $(this).animatedPng(options);
      $(this).dequeue();
    });
  });
};

var BrowserDetect = {
  init: function () {
    this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
    this.version =
      this.searchVersion(navigator.userAgent) ||
      this.searchVersion(navigator.appVersion) ||
      "an unknown version";
    this.OS = this.searchString(this.dataOS) || "an unknown OS";
  },

  searchString: function (data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      var dataProp = data[i].prop;

      this.versionSearchString = data[i].versionSearch || data[i].identity;

      if (dataString) {
        if (dataString.indexOf(data[i].subString) != -1) {
          return data[i].identity;
        }
      } else if (dataProp) {
        return data[i].identity;
      }
    }
  },

  searchVersion: function (dataString) {
    var index = dataString.indexOf(this.versionSearchString);

    if (index == -1) {
      return;
    }

    return parseFloat(
      dataString.substring(index + this.versionSearchString.length + 1)
    );
  },

  dataBrowser: [
    {
      string: navigator.userAgent,
      subString: "Chrome",
      identity: "Chrome",
    },
    {
      string: navigator.userAgent,
      subString: "OmniWeb",
      versionSearch: "OmniWeb/",
      identity: "OmniWeb",
    },
    {
      string: navigator.vendor,
      subString: "Apple",
      identity: "Safari",
      versionSearch: "Version",
    },
    {
      prop: window.opera,
      identity: "Opera",
    },
    {
      string: navigator.vendor,
      subString: "iCab",
      identity: "iCab",
    },
    {
      string: navigator.vendor,
      subString: "KDE",
      identity: "Konqueror",
    },
    {
      string: navigator.userAgent,
      subString: "Firefox",
      identity: "Firefox",
    },
    {
      string: navigator.vendor,
      subString: "Camino",
      identity: "Camino",
    },
    {
      // For newer Netscapes (6+)
      string: navigator.userAgent,
      subString: "Netscape",
      identity: "Netscape",
    },
    {
      string: navigator.userAgent,
      subString: "MSIE",
      identity: "Explorer",
      versionSearch: "MSIE",
    },
    {
      string: navigator.userAgent,
      subString: "Gecko",
      identity: "Mozilla",
      versionSearch: "rv",
    },
    {
      // For older Netscapes (4-)
      string: navigator.userAgent,
      subString: "Mozilla",
      identity: "Netscape",
      versionSearch: "Mozilla",
    },
  ],
  dataOS: [
    {
      string: navigator.platform,
      subString: "Win",
      identity: "Windows",
    },
    {
      string: navigator.platform,
      subString: "Mac",
      identity: "Mac",
    },
    {
      string: navigator.userAgent,
      subString: "iPhone",
      identity: "iPhone/iPod",
    },
    {
      string: navigator.platform,
      subString: "Linux",
      identity: "Linux",
    },
  ],
};

BrowserDetect.init();

function ViewerSupportsScaling() {
  return !(BrowserDetect.OS == "Mac" && BrowserDetect.browser != "Safari");
}

window.onunload = function () {
  if (!killViewer()) {
    return $(".onbeforeunload_text:first").text();
  }
};

function resizeViewer(sculpteo3Dviewer) {
  var data = $(sculpteo3Dviewer).data("viewer");
  var viewerId = data["viewerId"];
  var viewer = $("#Sculpteo3DViewer" + viewerId);
  var _width = viewer.parent().width();
  var _height = viewer.parent().height();
  /*
		If (_width > _height)
			_width = _height;
		if (_height > _width)
			_height = _width;
*/
  viewer.css("width", _width);
  viewer.css("height", _height);
  $("#Sculpteo3DImage" + viewerId).remove();
}

Sculpteo3DViewerEventHandler = function (
  sculpteo3Dviewer,
  subEventHandler,
  defaultTech
) {
  var handler = function () {
    if (!$(sculpteo3Dviewer).data("viewer")) {
      return;
    }

    var data = $(sculpteo3Dviewer).data("viewer");
    var viewerTech = defaultTech || data["viewerTech"];
    var viewer = $(sculpteo3Dviewer).Sculpteo3DViewer();
    var arguments__ = arguments;
    var args = new Array();

    for (var k = 0; k < arguments.length; k++) {
      args[k] = String(arguments[k]);
    }

    arguments__ = args;

    var event = String(arguments__[0]);

    switch (event) {
      case "progress":
        data = $(sculpteo3Dviewer).data("viewer");
        data["viewerLoaded"] = true;
        //log('Sculpteo3DViewer progress '+arguments__[1]);

        if (arguments__[1] == "100" || arguments__[1] == "MODEL_LOADED") {
          var control = $(sculpteo3Dviewer).data("control");

          if (data["options"].show_load_messages) {
            viewer.clearStatusMessage();
          }
          data["viewerReady"] = true;
          $(".module-loading", $(sculpteo3Dviewer).parent("._3dPanel")).hide();
          $(
            ".module-remotectrl",
            $(sculpteo3Dviewer).parent("._3dPanel")
          ).show();

          if (control) {
            control.show();
          }
        } else {
          if (arguments__[1] == "0") {
            viewer._rebuildScene();
          }
          if (data["options"].show_load_messages) {
            viewer.setStatusMessage(
              gettext("Loading 3D model"),
              true,
              parseFloat(arguments__[1]) / 100
            );
          }
        }

        $(sculpteo3Dviewer).data("viewer", data);
        break;
      case "hqrenderstart":
        viewer.setStatusMessage(gettext("High quality rendering"), true, 0);
        break;
      case "hqrenderstop":
        viewer.clearStatusMessage();
        break;
      case "new":
        log("Sculpteo3DViewer new");
        break;
      case "init":
        setTimeout(function () {
          log("Sculpteo3DViewer init");
          data = $(sculpteo3Dviewer).data("viewer");
          data["viewerLoaded"] = true;
          var pending = data["viewerPending"];

          data["viewerPending"] = [];
          $(sculpteo3Dviewer).data("viewer", data);

          for (var i = 0; i < pending.length; i++) {
            $(sculpteo3Dviewer).Sculpteo3DViewer(pending[i]);
          }

          $("#Sculpteo3DViewerSelect").removeClass("hidden");
          var namespace = "Sculpteo3DViewer" + data["viewerId"];
          var viewer = $(sculpteo3Dviewer).Sculpteo3DViewer();

          viewer._rebuildUI();

          viewer._rebuildScene();

          if (data["options"].showhelp) {
            viewer.setShowHelp(true);
          }
        }, 0);

        break;

      case "loadModelError":
        Utils.popupMessage(
          gettext(
            "Session error. You may need to leave this page to have it working again."
          ),
          "error"
        );
        break;
      case "log":
        $.post(URLS["x_remove_log"], {
          log: arguments__[1],
          referrer: document.referrer,
          location: $(location).attr("href"),
        });
        break;
      case "warnings":
        var warnings = eval(String(arguments__[1]));

        for (i in warnings) {
          var warning = warnings[i];
          var type = "warning";

          if (warning.type != "x") {
            if (warning.type == "h") {
              type = "hint";
            } else if (warning.type == "e") {
              type = "error";
            }

            Utils.popupMessage(
              String.format(gettext(warning.id), warning.params),
              type
            );
          }
        }

        break;
      case "camera":
        data["options"]["transform"] = arguments__.slice(1).join(",");
        $(sculpteo3Dviewer).Sculpteo3DViewer("idle", false);
        break;
      case "zoom":
        data["options"]["zoom"] = parseFloat(arguments__[1]);
        $(sculpteo3Dviewer).Sculpteo3DViewer("idle", false);
        break;
      case "pan":
        data["options"]["panx"] = parseFloat(arguments__[1]);
        data["options"]["pany"] = parseFloat(arguments__[2]);
        $(sculpteo3Dviewer).Sculpteo3DViewer("idle", false);
        break;
      case "click":
        $(sculpteo3Dviewer).Sculpteo3DViewer("idle", false);
        break;
      case "node":
        data = $(sculpteo3Dviewer).data("viewer");
        var node_instance = arguments__[1];
        var node_event = String(arguments__[2]);

        if (data["node_eventmap"] && data["node_eventmap"][node_instance]) {
          var node = data["node_eventmap"][node_instance];
          var node_event_args = arguments__.slice(3);

          // Update sculpteo3DViewer node info
          if (node_event == "transform") {
            node.transform = new Sculpteo3DViewerTransform3D(
              node_event_args[0]
            );
          }

          node.dispatchEvent(node_event, node_event_args);
        }

        break;
      case "layer":
        data = $(sculpteo3Dviewer).data("viewer");
        var layer_instance = arguments__[1];
        var layer_event = String(arguments__[2]);

        if (data["layer_eventmap"] && data["layer_eventmap"][layer_instance]) {
          var layer = data["layer_eventmap"][layer_instance];
          var layer_event_args = arguments__.slice(3);

          // Call node event listeners
          layer.dispatchEvent(layer_event, layer_event_args);
        }

        break;
      case "interrupted":
        var o = data["options"];

        for (var k in o.load) {
          var src = o.load[k];

          viewer.loadModel(src, k);
        }

        break;

      case "select_node":
        if (typeof viewer.onSelectNode == "function") {
          viewer.onSelectNode(arguments[1]);
        }

        break;

      case "mousedown":
        break;
      case "model_cube":
        if (data["nodes"]) {
          for (var k in data["nodes"]) {
            var node = data["nodes"][k];
            if (node.id == "model") {
              node.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_BBOX);
              node.setWireframeColor(68, 153, 234, 10);
            }
          }
        } else {
          data["model_cube"] = true;
        }
        break;
      case "nodeloaded":
        break;
      default:
        log("Sculpteo3DViewer Unhandled event " + event);
    }

    var handler = $(sculpteo3Dviewer).data("handler");

    if (handler && handler[event]) {
      var c = handler[event];

      for (var i = 0; i < c.length; i++) {
        var f = c[i];

        if (typeof f == "function") {
          f.apply(data["viewer"], arguments__.slice(1));
        }
      }
    }

    if (subEventHandler != null) {
      subEventHandler(arguments__);
    }
  };

  return handler;
};

function getModelSrc(src, viewerTech) {
  if (typeof src == "object") {
    var uuid = src.uuid;

    switch (viewerTech) {
      case "webgl":
        if (src.webgl) {
          return src.webgl + "?uuid=" + uuid;
        } else {
          return null;
        }

        break;
      case "canvas":
        if (src.canvas) {
          return src.canvas + "?uuid=" + uuid;
        } else {
          return null;
        }

        break;

      // Static: returns whole object for a full reload
      default:
        return src;
    }
  } else {
    return src;
  }
}

$.fn.Sculpteo3DViewerStatic = function (viewerId, options) {
  var $jself = $(this);
  var v = null;

  setTimeout(function () {
    $jself.Sculpteo3DViewer("loadViewer", "static");
  }, 0);
};

$.fn.Sculpteo3DViewerWebGL = function (viewerId, options) {
  var $jself = $(this);

  setTimeout(function () {
    $jself.Sculpteo3DViewer("loadViewer", "webgl");
  }, 0);
};

function killViewer(el) {
  if (!el) {
    el = $(".Sculpteo3DViewer");
  }

  var killed = true;

  $(el).each(function () {
    log("Kill viewer");
    killed &= $(el).Sculpteo3DViewer("kill");
  });

  return killed;
}

function addViewerSelect(jself, viewerId, options) {
  if (!options.show_viewer_select) {
    return;
  }

  // Add the viewer selection links
  if ($(".select_technology").length == 0) {
    jself.after(
      "<div id='Sculpteo3DViewerSelect' class='hidden' style='height:16px;line-height:16px;'><label class='inline' style='margin:0px; font-size: 9px;'>" +
        gettext("3D technology") +
        " : </label><span class='select_technology small' style='font-size: 9px;'></span></div>"
    );
  }

  // Var links = "<div id='Sculpteo3DViewerSelect' class='hidden' style='height:16px;line-height:16px;'>";
  var links = "";
  var others = Sculpteo3DViewerCaps;

  if (Sculpteo3DViewerTech == "webgl") {
    others &= ~Sculpteo3DViewerCap_webgl;
  }
  if (Sculpteo3DViewerTech == "static") {
    others &= ~Sculpteo3DViewerCap_static;
  }

  // Links+="<label class='inline' style='margin:0px;'>3D technology : </label><span class='select_technology small'>";

  if (others) {
    var separator = " | ";

    if (jself.width() < 300) {
      separator = "|";
    }

    if (Sculpteo3DViewerTechInit == "auto") {
      links +=
        '<u class="Sculpteo3DViewer' +
        viewerId +
        '_auto" style="text-decoration:none;">Auto</u>';
    } else {
      links +=
        '<a class="Sculpteo3DViewer' + viewerId + '_auto selectable">Auto</a>';
    }

    if (Sculpteo3DViewerTechInit == "webgl") {
      links +=
        separator +
        '<u class="Sculpteo3DViewer' +
        viewerId +
        '_webgl" style="text-decoration:none;">WebGL</u>';
    } else if (Sculpteo3DViewerCaps & Sculpteo3DViewerCap_webgl) {
      links +=
        separator +
        '<a class="Sculpteo3DViewer' +
        viewerId +
        '_webgl selectable">WebGL</a>';
    }

    if (Sculpteo3DViewerTechInit == "static") {
      links +=
        separator +
        '<u class="Sculpteo3DViewer' +
        viewerId +
        '_static" style="text-decoration:none;">JS</u>';
    } else if (Sculpteo3DViewerCaps & Sculpteo3DViewerCap_static) {
      links +=
        separator +
        '<a class="Sculpteo3DViewer' +
        viewerId +
        '_static selectable">JS</a>';
    }
  } else {
    links += '<u class="Sculpteo3DViewer' + viewerId + '_auto">Auto</u>';
  }

  // Links+="</span>";

  // $("#Sculpteo3DViewerSelect").html(links);
  $(".select_technology").html(links);

  $(".Sculpteo3DViewer" + viewerId + "_auto.selectable")
    .unbind("click")
    .click(function (evt) {
      jself.Sculpteo3DViewer("selectViewer", "auto");
    });

  $(".Sculpteo3DViewer" + viewerId + "_webgl.selectable")
    .unbind("click")
    .click(function (evt) {
      jself.Sculpteo3DViewer("selectViewer", "webgl");
      $(".module-remotectrl-content .auto-rotate").show();
    });

  $(".Sculpteo3DViewer" + viewerId + "_static.selectable")
    .unbind("click")
    .click(function (evt) {
      jself.Sculpteo3DViewer("selectViewer", "static");
    });
}

function WebGLDetect() {
  if (!window.WebGLRenderingContext) {
    return false;
  }

  var canvas;

  try {
    canvas = document.createElement("canvas");
  } catch (e) {
    return false;
  }

  var gl = null;
  var names = ["webgl", "experimental-webgl", "webkit-3d", "moz-webgl"];

  for (var i = 0; i < names.length; ++i) {
    try {
      gl = canvas.getContext(names[i]);
    } catch (e) {}

    if (gl) {
      break;
    }
  }

  if (!gl) {
    return false;
  }

  return true;
}

function Sculpteo3DViewerDetectCaps() {
  Sculpteo3DViewerCaps = Sculpteo3DViewerCap_static;

  if (WebGLDetect()) {
    Sculpteo3DViewerCaps |= Sculpteo3DViewerCap_webgl;
  }

  if (BrowserDetect.OS == "iPhone/iPod") {
    Sculpteo3DViewerCaps &= ~Sculpteo3DViewerCap_webgl;
  }

  Sculpteo3DViewerCaps &= Sculpteo3DViewerCapMask;
}

function fakeLoad(sculpteo3DViewer, url, callback) {
  var viewer_data = $(sculpteo3DViewer).data("viewer");

  $.ajax({
    url: url + "&viewer=static",
    cache: false,
    success: function (data, status, req) {
      var warnings = req.getResponseHeader("X-Sculpteo-Warnings");
      var static_handler = new Sculpteo3DViewerEventHandler(
        sculpteo3DViewer,
        viewer_data.options.eventhandler,
        "static"
      );

      if (warnings) {
        static_handler("warnings", warnings);
      }

      static_handler("progress", "100");
      callback();
    },

    error: function (req, textStatus, errorThrown) {
      var error = req.getResponseHeader("X-Sculpteo-Message");
      var static_handler = new Sculpteo3DViewerEventHandler(
        sculpteo3DViewer,
        viewer_data.options.eventhandler,
        "static"
      );

      if (error) {
        static_handler("errorMessage", error);
      }

      // We use code 409 to indicate outdated data, retry in this case
      if (req.status == 409) {
        log("409 -> interrupted");
        static_handler("interrupted", url);
      } else {
        static_handler("progress", "100");
      }
    },
  });
}

function measureText(font, text) {
  var control = document.createElement("span");

  control.style.display = "inline";
  control.font = font;
  control.textContent = text;

  return {
    height: control.offsetHeight,
    width: control.offsetWidth,
  };
}

function getSculpteo3DViewer(el) {
  return $(el).closest(".Sculpteo3DViewer");
}

function getSculpteo3DInternalViewer(el) {
  return $(el).closest(".Sculpteo3DViewer").Sculpteo3DViewer("viewer");
}

function CameraRotation(targetVector) {
  this[0] = targetVector[0];
  this[1] = targetVector[1];
  this[2] = targetVector[2];
}

// http://stackoverflow.com/questions/1171849/finding-quaternion-representing-the-rotation-from-one-vector-to-another

CameraRotation.X_AXIS = [1, 0, 0];
CameraRotation.Y_AXIS = [0, 1, 0];
CameraRotation.Y_AXIS_OPP = [0, -1, 0];
CameraRotation.Z_AXIS = [0, 0, 1];

CameraRotation.orthonormal = function (v) {
  var x = v[0];
  var y = v[1];
  var z = v[2];
  var u;

  if (x < y) {
    if (x < z) {
      u = CameraRotation.X_AXIS;
    } else {
      u = CameraRotation.Z_AXIS;
    }
  } else {
    if (y < z) {
      u = CameraRotation.Y_AXIS;
    } else {
      u = CameraRotation.Z_AXIS;
    }
  }

  return Sculpteo3DViewerTransform3D.crossProduct(v, u);
};

CameraRotation.buildQuaternionFromUtoV = function (u, v) {
  var cos = Sculpteo3DViewerTransform3D.dotProduct(u, v);
  var k = Math.sqrt(
    Sculpteo3DViewerTransform3D.dotProduct(u, u) *
      Sculpteo3DViewerTransform3D.dotProduct(v, v)
  );

  if (Math.abs(cos / k + 1) < 0.001) {
    var axis = Sculpteo3DViewerTransform3D.crossProduct(
      v,
      CameraRotation.orthonormal(v)
    );
    var q = [0, axis[0], axis[1], axis[2]];

    return Sculpteo3DViewerTransform3D.quatNormalize(q);
  }

  var axis = Sculpteo3DViewerTransform3D.crossProduct(v, u);
  var w = cos + k;
  var q = [w, axis[0], axis[1], axis[2]];

  return Sculpteo3DViewerTransform3D.quatNormalize(q);
};

CameraRotation.prototype.buildRotationFrom = function (v) {
  return CameraRotation.buildQuaternionFromUtoV(v, this);
};

// Wrapper for easier access to the abstract viewer, that is
// $(selector).Sculpteo3DViewer().loadModel(url)
// instead of
// $(selector).Sculpteo3DViewer({ src: url })
function Sculpteo3DViewer($jself) {
  this.$jself = $jself;
}

// Private function to get current viewer instance, in whatever 3D technology is currently used;
// may return undefined if no viewer implementation is currently running
Sculpteo3DViewer.prototype._getViewerInstance = function () {
  var data = this.$jself.data("viewer");

  if (data) {
    if (!data["viewerLoaded"]) {
      return;
    }

    return data["viewer"];
  }
};

Sculpteo3DViewer.prototype.getWidth = function () {
  return this.$jself.width();
};

Sculpteo3DViewer.prototype.getHeight = function () {
  return this.$jself.height();
};

Sculpteo3DViewer.prototype.isAlive = function () {
  return this._getViewerInstance() ? true : false;
};

Sculpteo3DViewer.prototype.setFading = function (enable) {
  this.$jself.Sculpteo3DViewer({ fading: enable });
};

Sculpteo3DViewer.prototype.fitModelsInView = function (enable) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.fitModelsInView();
};

Sculpteo3DViewer.prototype.setLoadingComplete = function (enable) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLoadingComplete();
};

Sculpteo3DViewer.prototype.loadModel = function (url, id) {
  if (typeof id == "undefined") {
    id = "model";
  }

  var load = {};

  load[id] = url;

  this.$jself.Sculpteo3DViewer({ load: load });
};

Sculpteo3DViewer.prototype.getGroups = function (id) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  if (typeof id == "undefined") {
    id = "model";
  }

  return instance.getGroups(id);
};

Sculpteo3DViewer.prototype._rebuildScene = function () {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  var data = this.$jself.data("viewer");

  // Restore dirty bit for animation
  if (
    data["viewerTech"] &&
    data["viewerTech"] == "webgl" &&
    data["animation"] &&
    !$.isEmptyObject(data["animation"])
  ) {
    instance.setLocal(true);
  }

  // Restore nodes
  var root = this.getScene();

  root.instance = instance.sceneReset();

  if (!data["nodes"]) {
    data["nodes"] = {};
  }

  for (var k in data["nodes"]) {
    var node = data["nodes"][k];

    if (node != root) {
      node.instance = instance.createNode(
        node.id,
        node.transform ? node.transform.toString() : undefined,
        node.material,
        node.flags
      );
    }

    // Restore full material
    node.setMaterial(
      node.material,
      node.envmap,
      node.smooth,
      node.bumpnoise,
      node.gaussian_amplitude
    );

    // Restore node style
    node.setDrawMode(node.drawMode);
    node.setBboxColor(
      node.bboxColor.r,
      node.bboxColor.g,
      node.bboxColor.b,
      node.bboxColor.a
    );
    node.setWireframeColor(
      node.wireframeColor.r,
      node.wireframeColor.g,
      node.wireframeColor.b,
      node.wireframeColor.a
    );

    if (node.group) {
      node.setGroup(node.group);
    }

    // Restore node events
    node.setInteractive(node.interactive);

    // Restore node solidity
    if (node.solidity) {
      node.setSolidity(node.solidity[0], node.solidity[1]);
    }

    if (node.instance) {
      this._mapNodeEvent(node.instance, node);
    }
  }

  // Now that all nodes have instance, restore hierarchy
  for (var k in data["nodes"]) {
    var node = data["nodes"][k];

    for (var n in node.childNodes) {
      var child = node.childNodes[n];

      this._attachNode(
        node.instance,
        child.instance,
        child.operation,
        child.flags
      );
    }
  }
};

Sculpteo3DViewer.prototype._getData = function () {
  var data = this.$jself.data("viewer");

  if (!data) {
    data = {};
    this.$jself.data("viewer", data);
  }

  return data;
};

Sculpteo3DViewer.prototype.clearScene = function () {
  var instance = this._getViewerInstance();
  var root_node_instance = undefined;

  if (instance) {
    root_node_instance = instance.sceneReset();
  }

  var data = this._getData();

  data["scene"] = new Sculpteo3DViewerSceneNode(
    this,
    root_node_instance,
    "root"
  );

  return data["scene"];
};

Sculpteo3DViewer.prototype.clearSceneComplete = function () {
  var data = this.$jself.data("viewer");

  delete data["nodes"];
  delete data["scene"];
  delete data["node_eventmap"];
  var instance = this._getViewerInstance();

  if (instance) {
    var rootkey = instance.sceneReset();
    if (instance.nodesReset) {
      instance.nodesReset();
    }
    var modelkey = instance.createNode("model");

    instance._attachNode(rootkey, modelkey);
  }

  this.getScene();
};

Sculpteo3DViewer.prototype.getScene = function () {
  var data = this._getData();

  var root;

  if (!data["scene"]) {
    root = new Sculpteo3DViewerSceneNode(this, undefined, "root");
    var model = new Sculpteo3DViewerSceneNode(this, undefined, "model");

    if (data["model_cube"]) {
      model.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_BBOX);
      model.setWireframeColor(68, 153, 234, 10);
    }

    root.childNodes = [model];
    data["scene"] = root;
  } else {
    root = data["scene"];
  }

  return root;
};

Sculpteo3DViewer.prototype.createNode = function (model, transform, material) {
  var instance = this._getViewerInstance();
  var node_instance = undefined;

  if (instance) {
    node_instance = instance.createNode(
      model,
      transform ? transform.toString() : undefined,
      material
    );
  }

  return new Sculpteo3DViewerSceneNode(
    this,
    node_instance,
    model,
    transform,
    material
  );
};

Sculpteo3DViewer.prototype._deleteNode = function (node_instance) {
  var instance = this._getViewerInstance();

  if (!instance || !instance.deleteNode) {
    return;
  }

  instance.deleteNode(node_instance);
};

Sculpteo3DViewer.prototype.deleteNodeModel = function (model) {
  var instance = this._getViewerInstance();

  if (!instance || !instance.deleteNode) {
    return;
  }

  instance.deleteNodeModel(model);
};

Sculpteo3DViewer.prototype._attachNode = function (
  parent_instance,
  child_instance,
  op
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  // Log("attach " + parent_instance + "," + child_instance);
  instance._attachNode(parent_instance, child_instance, op);
};

Sculpteo3DViewer.prototype.getNodesByName = function (name) {
  var nodes = this.__getAllNodes();
  var found_nodes = new Array();

  for (var i = 0; i < nodes.length; i++) {
    if (!name || nodes[i].id == name) {
      found_nodes.push(nodes[i]);
    }
  }

  return found_nodes;
};

Sculpteo3DViewer.prototype.getNodeByInstance = function (instance) {
  var nodes = this.__getAllNodes();

  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].instance == instance) {
      return nodes[i];
    }
  }

  return null;
};

Sculpteo3DViewer.prototype.__getAllNodes = function (node) {
  var node_list = new Array();

  if (!node) {
    var data = this.$jself.data("viewer");

    if (data && data["nodes"]) {
      var nodes = data["nodes"];

      for (var k in nodes) {
        var n = nodes[k];

        node_list.push(n);
      }
    }

    return node_list;
  }

  node_list.push(node);

  for (var n in node.childNodes) {
    // Same as python extend
    node_list.push.apply(
      node_list,
      this.__getAllNodes(node.childNodes[n], node_list)
    );
  }

  return node_list;
};

Sculpteo3DViewer.prototype._detachNode = function (node_instance) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._detachNode(node_instance);
};

Sculpteo3DViewer.prototype._mapNodeEvent = function (node_instance, node) {
  var data = this.$jself.data("viewer");

  if (!data["node_eventmap"]) {
    data["node_eventmap"] = {};
  }

  data["node_eventmap"][node_instance] = node;
};

Sculpteo3DViewer.prototype._setNodeMaterial = function (
  node_instance,
  material,
  envmap,
  smooth,
  bumpnoise,
  gauss
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeMaterial(
    node_instance,
    material,
    envmap,
    smooth,
    bumpnoise,
    gauss
  );
};

Sculpteo3DViewer.prototype._setNodeSolidity = function (
  node_instance,
  min_solidity,
  max_solidity
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeSolidity(node_instance, min_solidity, max_solidity);
};

Sculpteo3DViewer.prototype._setNodeFlags = function (node_instance, flags) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeFlags(node_instance, flags);
};

Sculpteo3DViewer.prototype._setNodeGroup = function (node_instance, group) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeGroup(node_instance, group);
};

Sculpteo3DViewer.prototype._setNodeOpacity = function (node_instance, opacity) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeOpacity(node_instance, opacity);
};

Sculpteo3DViewer.prototype._setNodeTransform = function (
  node_instance,
  transform
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeTransform(node_instance, transform);
};

Sculpteo3DViewer.prototype._setNodeInteractive = function (
  node_instance,
  enable
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeInteractive(node_instance, enable);
};

Sculpteo3DViewer.prototype._setNodeDrawMode = function (node_instance, mask) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeDrawMode(node_instance, mask);
};

Sculpteo3DViewer.prototype._setNodeBboxColor = function (
  node_instance,
  r,
  g,
  b,
  a
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeBboxColor(node_instance, r, g, b, a);
};

Sculpteo3DViewer.prototype.createBbox = function (bbox, color) {
  var id = Utils.uniqueString();
  var viewer = this;
  var scene = viewer.getScene();
  var node = viewer.createNode(id);

  node.setBboxColor(color.r, color.g, color.b, color.a);
  scene.appendChild(node);
  node.setInteractive(Sculpteo3DViewerCommon.INTERACTIVE_BBOX);
  var v = viewer._getViewerInstance();

  v.setBbox(id, bbox);
  //var R = new Sculpteo3DViewerTransform3D().rotateQ(rot[0], rot[1], rot[2], rot[3]);
  //var T = new Sculpteo3DViewerTransform3D().translate(trans[0], trans[1], trans[2]);
  //var _M = R.x(S);
  //var M = T.x(_M);
  //node.setTransform(M);

  return node;
};

Sculpteo3DViewer.prototype.createMeshBbox = function () {
  var viewer = this;
  var v = viewer._getViewerInstance();
  return this.createBbox(v._mesh_bbox, { r: 255, b: 255, g: 255, a: 0 });
};

Sculpteo3DViewer.prototype._setNodeWireframeColor = function (
  node_instance,
  r,
  g,
  b,
  a
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._setNodeWireframeColor(node_instance, r, g, b, a);
};

Sculpteo3DViewer.prototype.setCursorNode = function (node) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setDraggedNode(node ? node.instance : null);
};

Sculpteo3DViewer.prototype.getCursorTransform = function (x, y) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  var arr = instance.getCursorTransform(x, y);

  if (arr == null) {
    return new Sculpteo3DViewerCommonTransform3D();
  } else {
    return new Sculpteo3DViewerCommonTransform3D(arr);
  }
};

Sculpteo3DViewer.prototype.getCursorNormal = function (x, y) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  if (instance.getCursorNormal) {
    return instance.getCursorNormal(x, y);
  } else {
    console.log("not implemented");

    return null;
  }
};

Sculpteo3DViewer.prototype.setDraggedNode =
  Sculpteo3DViewer.prototype.setCursorNode;

Sculpteo3DViewer.prototype._rebuildUI = function () {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  var data = this.$jself.data("viewer");

  // Restore images
  if (!data["images"]) {
    data["images"] = {};
  }

  for (var k in data["images"]) {
    var image = data["images"][k];

    image.instance = instance.createImage(image.url);
  }

  // Restore layers
  var root = this.getRootLayer();

  root.instance = instance.rootLayer();

  if (!data["layers"]) {
    data["layers"] = {};
  }

  for (var k in data["layers"]) {
    var layer = data["layers"][k];

    if (layer != root) {
      layer.instance = instance.createLayer();
    }

    // Restore layer state
    this._setLayerInteractive(layer.instance, layer.interactive);

    layer._setStyle(layer);

    // Map events
    if (layer.listeners) {
      this._mapLayerEvent(layer.instance, layer);
    }
  }

  // Now that all layers have instance, restore hierarchy
  for (var k in data["layers"]) {
    var layer = data["layers"][k];

    for (var n in layer.childLayers) {
      this._attachLayer(layer.instance, layer.childLayers[n].instance);
    }
  }
};

Sculpteo3DViewer.prototype.getRootLayer = function () {
  var data = this.$jself.data("viewer");
  var root;

  if (!data["ui"]) {
    root = new Sculpteo3DViewerUILayer(this, undefined);
    root.setFrame(0, 0, this.$jself.width(), this.$jself.height());
    data["ui"] = root;
  } else {
    root = data["ui"];
  }

  return root;
};

Sculpteo3DViewer.prototype.createImage = function (url) {
  var instance = this._getViewerInstance();
  var image_instance = undefined;

  if (instance) {
    image_instance = instance.createImage(url);
  }

  var image = new Sculpteo3DViewerImage(this, image_instance, url);

  var data = this.$jself.data("viewer");

  if (!data["images"]) {
    data["images"] = {};
  }

  data["images"][image.key] = image;

  return image;
};

Sculpteo3DViewer.prototype._deleteImage = function (image) {
  var data = this.$jself.data("viewer");

  if (!data["images"]) {
    data["images"] = {};
  }

  delete data["images"][image.key];
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.deleteImage(image.instance);
};

Sculpteo3DViewer.prototype.createUILayer = function (options) {
  return new Sculpteo3DViewerUILayer(this, options);
};

Sculpteo3DViewer.prototype.createUILabel = function (options) {
  return new Sculpteo3DViewerUILabel(this, options);
};

Sculpteo3DViewer.prototype.createUIButton = function (options) {
  return new Sculpteo3DViewerUIButton(this, options);
};

Sculpteo3DViewer.prototype.createUIToggleButton = function (options) {
  return new Sculpteo3DViewerUIToggleButton(this, options);
};

Sculpteo3DViewer.prototype.createUISlider = function (options) {
  return new Sculpteo3DViewerUISlider(this, options);
};

Sculpteo3DViewer.prototype.createUIAlert = function (options) {
  return new Sculpteo3DViewerUIAlert(this, options);
};

Sculpteo3DViewer.prototype.createUIMenu = function (options) {
  return new Sculpteo3DViewerUIMenu(this, options);
};

Sculpteo3DViewer.prototype.createUIThrobber = function (options) {
  return new Sculpteo3DViewerUIThrobber(this, options);
};

Sculpteo3DViewer.prototype._deleteLayer = function (layer) {
  var data = this.$jself.data("viewer");

  if (!data["layers"]) {
    data["layers"] = {};
  }

  delete data["layers"][layer.key];

  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.deleteLayer(layer.instance);
};

Sculpteo3DViewer.prototype._attachLayer = function (
  parent_instance,
  child_instance
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._attachLayer(parent_instance, child_instance);
};

Sculpteo3DViewer.prototype._detachLayer = function (layer_instance) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance._detachLayer(layer_instance);
};

Sculpteo3DViewer.prototype._mapLayerEvent = function (layer_instance, layer) {
  var data = this.$jself.data("viewer");

  if (!data["layer_eventmap"]) {
    data["layer_eventmap"] = {};
  }

  data["layer_eventmap"][layer_instance] = layer;
};

Sculpteo3DViewer.prototype._setLayerInteractive = function (
  layer_instance,
  enable
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerInteractive(layer_instance, enable);
};

Sculpteo3DViewer.prototype._addLayerClass = function (
  layer_instance,
  className
) {
  var instance = this._getViewerInstance();

  if (!instance || !instance.addLayerClass) {
    return;
  }

  instance.addLayerClass(layer_instance, className);
};

Sculpteo3DViewer.prototype._setLayerFrame = function (
  layer_instance,
  x,
  y,
  w,
  h
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerFrame(layer_instance, x, y, w, h);
};

Sculpteo3DViewer.prototype._setLayerBorderColor = function (
  layer_instance,
  r,
  g,
  b,
  a
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerBorderColor(layer_instance, r, g, b, a);
};

Sculpteo3DViewer.prototype._setLayerBorderWidth = function (
  layer_instance,
  width
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerBorderWidth(layer_instance, width);
};

Sculpteo3DViewer.prototype._setLayerBorderRadius = function (
  layer_instance,
  radius
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerBorderRadius(layer_instance, radius);
};

Sculpteo3DViewer.prototype._setLayerBackgroundColor = function (
  layer_instance,
  r,
  g,
  b,
  a
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerBackgroundColor(layer_instance, r, g, b, a);
};

Sculpteo3DViewer.prototype._setLayerBackgroundImage = function (
  layer_instance,
  image_instance,
  offx,
  offy
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerBackgroundImage(layer_instance, image_instance, offx, offy);
};

Sculpteo3DViewer.prototype._setLayerBackgroundText = function (
  layer_instance,
  font,
  str,
  color,
  offx,
  offy
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerBackgroundText(
    layer_instance,
    font,
    str,
    color.r,
    color.g,
    color.b,
    color.a,
    offx,
    offy
  );
};

Sculpteo3DViewer.prototype._setLayerOpacity = function (
  layer_instance,
  opacity
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setLayerOpacity(layer_instance, opacity);
};

Sculpteo3DViewer.prototype._setZIndex = function (layer_instance, zIndex) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  instance.setZIndex(layer_instance, zIndex);
};

Sculpteo3DViewer.prototype.setAnimation = function (callback, duration) {
  var viewer = this;
  var key = "";

  for (i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  var animation = { key: key, start: +new Date(), duration: duration };
  var f = function () {
    var now = +new Date();

    var data = this.$jself.data("viewer");

    if (data["viewerTech"] && data["viewerTech"] == "webgl") {
      // Animations are webgl only currently
      callback.call(animation, now - animation.start);
    }

    if (animation.duration) {
      if (now - animation.start < animation.duration) {
        animation.timer = setTimeout(f, 16);
      } else {
        viewer.clearAnimation(animation);
      }
    }
  };

  if (duration) {
    animation.timer = setTimeout(f, 16);
  } else {
    animation.timer = setInterval(f, 16);
  }

  var data = this.$jself.data("viewer");

  if (!data["animation"]) {
    data["animation"] = {};
  }

  var animations = data["animation"];

  animations[key] = animation;

  if (!(data["viewerTech"] && data["viewerTech"] == "webgl")) {
    return;
  }

  var instance = this._getViewerInstance();

  if (!instance) {
    return animation;
  }

  // Prevent remote render
  instance.setLocal(true);

  return animation;
};

Sculpteo3DViewer.prototype.clearAnimation = function (animation) {
  if (animation.duration) {
    clearTimeout(animation.timer);
  } else {
    clearInterval(animation.timer);
  }

  var data = this.$jself.data("viewer");

  if (!data["animation"]) {
    data["animation"] = {};
  }

  var animations = data["animation"];

  delete animations[animation.key];

  if (!(data["viewerTech"] && data["viewerTech"] == "webgl")) {
    return;
  }

  var instance = this._getViewerInstance();

  if (!instance) {
    return;
  }

  if ($.isEmptyObject(animations)) {
    // No more animations, restore remote render
    instance.setLocal(false);
    instance.setUpdate();
  }
};

Sculpteo3DViewer.prototype.resetView = function () {
  this.$jself.Sculpteo3DViewer({ resetview: true });
};

Sculpteo3DViewer.prototype.setLocal = function (local) {
  var oldLocal = this.getLocal();
  this.$jself.Sculpteo3DViewer({ local: local });
  return oldLocal;
};

Sculpteo3DViewer.prototype.getLocal = function () {
  var data = this.$jself.data("viewer");

  if (!data || !data["options"] || !data["options"]["local"]) {
    return false;
  }

  return data["options"]["local"];
};

Sculpteo3DViewer.prototype.setAutorotate = function (enable) {
  this.$jself.Sculpteo3DViewer({ autorotate: enable });
};

Sculpteo3DViewer.prototype.toggleAutorotate = function (enable) {
  this.$jself.Sculpteo3DViewer({ toggleAutorotate: true });
};

Sculpteo3DViewer.prototype.setMaterial = function (material) {
  this.$jself.Sculpteo3DViewer({ material: material });
};

Sculpteo3DViewer.prototype.getBackgroundColor = function (r, g, b) {
  var data = this.$jself.data("viewer");
  var c = data["viewer"]["bgcolor"];
  var r = parseInt(c.substr(1, 2), 16);
  var g = parseInt(c.substr(3, 2), 16);
  var b = parseInt(c.substr(5, 2), 16);

  return [r, g, b];
};

Sculpteo3DViewer.prototype.setBackgroundColor = function (r, g, b) {
  this.$jself.Sculpteo3DViewer({ bgcolor: [r, g, b] });
};

Sculpteo3DViewer.prototype.setSelectionColor = function (r, g, b, a) {
  this.$jself.Sculpteo3DViewer({ selcolor: [r, g, b, a] });
};

Sculpteo3DViewer.prototype.setDoubleCut = function (x, y, z, min, max) {
  this.$jself.Sculpteo3DViewer({ cutAxis: [x, y, z, min], doubleCut: max });
};

Sculpteo3DViewer.prototype.clrDoubleCut = function () {
  this.$jself.Sculpteo3DViewer({ cutAxis: null, doubleCut: undefined });
};

Sculpteo3DViewer.prototype.setCutAxis = function (x, y, z, w) {
  this.$jself.Sculpteo3DViewer({ cutAxis: [x, y, z, w] });
};

Sculpteo3DViewer.prototype.clrCutAxis = function () {
  this.$jself.Sculpteo3DViewer({ cutAxis: null });
};

Sculpteo3DViewer.prototype.clrCutColor = function () {
  this.$jself.Sculpteo3DViewer({ cutColor: [] });
};

Sculpteo3DViewer.prototype.setCutColor = function (
  r,
  g,
  b,
  margin,
  back_r,
  back_g,
  back_b
) {
  this.$jself.Sculpteo3DViewer({
    cutColor: [r, g, b, margin, back_r, back_g, back_b],
  });
};

Sculpteo3DViewer.prototype.setUnits = function (units) {
  this.$jself.Sculpteo3DViewer({ units: units });
};

// Set the CSG rendering mode, if supported by the viewer
Sculpteo3DViewer.CSG_MODE_NONE = 0; // No CSG rendering, interescted and subtracted shapes are drawn in wireframe
Sculpteo3DViewer.CSG_MODE_CONVEX = 1; // Convex CSG rendering, boolean operations involving non-convex shapes may not be drawn properly
Sculpteo3DViewer.CSG_MODE_ANY = 2; // Generic CSG rendering, operations are always rendered properly
Sculpteo3DViewer.prototype.setCSGMode = function (mode) {
  this.$jself.Sculpteo3DViewer({ csgmode: mode });
};

Sculpteo3DViewer.prototype.setPerspective = function (enable) {
  this.$jself.Sculpteo3DViewer({ perspective: enable });
};

Sculpteo3DViewer.prototype.setWireframe = function (wireframe) {
  this.$jself.Sculpteo3DViewer({ wireframe: wireframe });
};

Sculpteo3DViewer.prototype.setPointCloud = function (pointcloud) {
  this.$jself.Sculpteo3DViewer({ pointcloud: pointcloud });
};

Sculpteo3DViewer.prototype.setOrientation = function (orientation) {
  this.$jself.Sculpteo3DViewer({ orientation: orientation });
};

Sculpteo3DViewer.prototype.setShowHelp = function (help) {
  var data = this.$jself.data("viewer");

  if (!data.uiHelpLayer) {
    data.uiHelpImage = this.createImage(STATIC_URL + "css/images/mouse.png");
    data.uiHelpLayer = this.createUILayer({
      backgroundImage: data.uiHelpImage,
      frame: { x: 0, y: 0, w: 90, h: 30 },
    });
  }

  // Put in top right corner
  data.uiHelpLayer.setFrame(this.getWidth() - 100, 12);

  this.getRootLayer().appendChild(data.uiHelpLayer);

  var that = this;

  setTimeout(function () {
    data.uiHelpLayer.detach();
  }, 15000);
};

Sculpteo3DViewer.prototype.setIssues = function (issues) {
  this.$jself.Sculpteo3DViewer({ issues: issues });
};

Sculpteo3DViewer.prototype.setSelectedFaces = function (selectedFaces) {
  this.$jself.Sculpteo3DViewer({ selectedfaces: selectedFaces });
};

Sculpteo3DViewer.prototype.setBackgroundImage = function (bgimage) {
  if (bgimage) {
    this.$jself.Sculpteo3DViewer({ bgImage: bgimage });
  } else {
    this.$jself.Sculpteo3DViewer({ unsetBgImage: true });
  }
};

Sculpteo3DViewer.prototype.getTransform = function () {
  var data = this.$jself.data("viewer");

  if (!data["options"] || !data["options"]["transform"]) {
    return "1,0,0,0";
  }

  return data["options"]["transform"];
};

Sculpteo3DViewer.prototype.setSceneTransform = function (transform) {
  this.$jself.Sculpteo3DViewer({ sceneTransform: transform });
};

Sculpteo3DViewer.prototype.updateSceneTransform = function () {
  var size = this.getSceneSize();
  if (!size || size.x < 0) {
    return;
  }
  var scale = Math.max(size.x, size.y, size.z);

  scale *= 0.5;

  var transform = Sculpteo3DViewerTransform3D.identity;
  var s = Sculpteo3DViewerTransform3D.scale(scale, scale, scale);
  var m = Sculpteo3DViewerTransform3D.translation(size.cx, size.cy, size.cz);

  transform = transform.x(m);
  transform = transform.x(s);
  transform = transform.inverse();

  this.setSceneTransform(transform.toString());
};

Sculpteo3DViewer.prototype.updateSceneCenter = function () {
  var sceneTransform = this.getSceneTransform();
  var decomp = sceneTransform.decompose();
  var scale = 1 / decomp.scale;

  var size = this.getSceneSize();
  if (!size || size.x < 0) {
    return;
  }

  var transform = Sculpteo3DViewerTransform3D.identity;
  var s = Sculpteo3DViewerTransform3D.scale(scale, scale, scale);
  var m = Sculpteo3DViewerTransform3D.translation(size.cx, size.cy, size.cz);

  transform = transform.x(m);
  transform = transform.x(s);
  transform = transform.inverse();

  this.setSceneTransform(transform.toString());
};

Sculpteo3DViewer.prototype.centerZoomToScene = function (zoom) {
  var sceneTransform = this.getSceneTransform();
  var decomp = sceneTransform.decompose();
  var old_scale = 1 / decomp.scale;

  var size = this.getSceneSize();
  if (!size || size.x < 0) {
    return;
  }

  var transform = Sculpteo3DViewerTransform3D.identity;
  var s = Sculpteo3DViewerTransform3D.scale(old_scale, old_scale, old_scale);
  var m = Sculpteo3DViewerTransform3D.translation(size.cx, size.cy, size.cz);

  transform = transform.x(m);
  transform = transform.x(s);
  transform = transform.inverse();

  this.setSceneTransform(transform.toString());

  var scale = Math.max(size.x, size.y, size.z);

  scale *= 0.5;

  this.setZoom((zoom * scale) / old_scale);
};

Sculpteo3DViewer.prototype.setDesignUUID = function (uuid) {
  this.$jself.Sculpteo3DViewer({ designUUID: uuid });
};

Sculpteo3DViewer.prototype.getWorldToViewportTransform = function () {
  var scene_transform = this.getSceneTransform();
  var zoom = this.getZoom();
  var pan = this.getPan();

  // Compute mvMatrix
  var mvMatrix = new Sculpteo3DViewerTransform3D();

  mvMatrix = mvMatrix.rotate((-90.0 * Math.PI) / 180.0, 1, 0, 0);
  mvMatrix = mvMatrix.translate(pan.x * zoom, pan.y * zoom, 0);
  var rot = this.getTransform().split(",");

  var R = Sculpteo3DViewerTransform3D.quatMat3(
    parseFloat(rot[0]),
    parseFloat(rot[1]),
    parseFloat(rot[2]),
    parseFloat(rot[3])
  );
  var R4 = new Sculpteo3DViewerTransform3D([
    R[0],
    R[1],
    R[2],
    0,
    R[3],
    R[4],
    R[5],
    0,
    R[6],
    R[7],
    R[8],
    0,
    0,
    0,
    0,
    1,
  ]);

  mvMatrix = mvMatrix.x(R4);
  mvMatrix = mvMatrix.x(scene_transform);

  // Compute pMatrix
  var viewportWidth = this.$jself.width();
  var viewportHeight = this.$jself.height();
  var ar = viewportWidth / viewportHeight;
  var zoomx, zoomy;

  if (ar > 1.0) {
    zoomx = zoom * ar;
    zoomy = zoom;
  } else {
    zoomx = zoom;
    zoomy = zoom / ar;
  }

  var pMatrix = new Sculpteo3DViewerTransform3D([
    (0.5 * viewportWidth) / zoomx,
    0.0,
    0.0,
    0.5 * viewportWidth,
    0.0,
    (-0.5 * viewportHeight) / zoomy,
    0.0,
    0.5 * viewportHeight,
    0.0,
    0.0,
    0.0,
    0.0,
    0.0,
    0.0,
    0.0,
    1.0,
  ]);

  return pMatrix.x(mvMatrix);
};

Sculpteo3DViewer.prototype.resize = function (width, height) {
  var instance = this._getViewerInstance();

  if (instance && instance.resize) {
    instance.resize(width, height);
  }
};

Sculpteo3DViewer.prototype.getSceneTransform = function () {
  var instance = this._getViewerInstance();

  if (!instance) {
    return new Sculpteo3DViewerTransform3D();
  }

  return new Sculpteo3DViewerTransform3D(instance.getSceneTransform());
};

Sculpteo3DViewer.prototype.getSnapshotUrl = function (
  width,
  height,
  quality,
  options
) {
  var instance = this._getViewerInstance();

  if (!instance) {
    return "";
  }

  var url = instance.getSnapshotUrl(width, height, quality);

  if (options) {
    for (var k in options) {
      var v = options[k];

      url = url.replace(RegExp(k + "=([^&]*)"), k + "=" + v);
    }
  }

  return url;
};

Sculpteo3DViewer.prototype.animateCamera = function (
  rotq,
  pan,
  zoom,
  duration,
  easing,
  done
) {
  // Reuse easing functions from jQuery
  if (!easing) {
    easing = "swing";
  }

  if (typeof easing != "function") {
    easing = $.easing[easing];
  }

  var time1 = +new Date();
  var that = this;
  var animation = new Sculpteo3DViewerUIAnimation();

  var srcQ, dstQ;
  var srcScale, dstScale;
  var srcTranslation, dstTranslation;

  srcQ = this.getTransform().split(",");

  for (var i = 0; i < 4; i++) {
    srcQ[i] = parseFloat(srcQ[i]);
  }

  if (typeof rotq != "undefined") {
    if (rotq[0] == 0 && rotq[1] == 0 && rotq[2] == 0 && rotq[3] == 0) {
      rotq[0] = 1;
    }

    dstQ = Sculpteo3DViewerTransform3D.quatNormalize(rotq);
  } else {
    dstQ = srcQ;
  }

  srcScale = parseFloat(this.getZoom());

  if (typeof zoom != "undefined") {
    dstScale = zoom;
  } else {
    dstScale = srcScale;
  }

  srcTranslation = this.getPan();
  srcTranslation = [srcTranslation.x, srcTranslation.y];

  if (typeof pan != "undefined") {
    dstTranslation = pan;
  } else {
    dstTranslation = srcTranslation;
  }

  var anim = function () {
    var time2 = +new Date();
    var percent = 1.0;
    if (duration) {
      percent = (time2 - time1) / duration;
    }

    if (percent > 1.0) {
      percent = 1.0;
    }

    var v = easing(percent, duration * percent, 0, 1, duration);

    var options = {};

    // Spherical interpolation of rotations
    if (srcQ !== dstQ) {
      var intQ = Sculpteo3DViewerTransform3D.quatSlerp(srcQ, dstQ, v);
      options["transform"] = intQ.join(",");
    }

    if (srcScale !== dstScale) {
      var intScale = (1 - v) * srcScale + v * dstScale;
      options["zoom"] = intScale;
    }
    // Linear interpolation of scale and translation

    if (srcTranslation !== dstTranslation) {
      var intTranslation = [
        (1 - v) * srcTranslation[0] + v * dstTranslation[0],
        (1 - v) * srcTranslation[1] + v * dstTranslation[1],
      ];
      options["pan"] = { x: intTranslation[0], y: intTranslation[1] };
    }

    that.$jself.Sculpteo3DViewer(options);

    if (percent < 1.0) {
      animation.timeout = setTimeout(anim, 16);
    } else if (typeof done == "function") {
      done.call(this);
    }
  };

  animation.timeout = setTimeout(anim);

  return animation;
};

Sculpteo3DViewer.prototype.setTransform = function (transform) {
  this.$jself.Sculpteo3DViewer({ transform: transform });
};

Sculpteo3DViewer.prototype.getSceneBBox = function () {
  var instance = this._getViewerInstance();

  if (instance) {
    return instance.getSceneBBox();
  } else {
    return null;
  }
};

Sculpteo3DViewer.prototype.getSceneSize = function () {
  var bbox = this.getSceneBBox();

  if (bbox == "" || bbox == null) {
    return null;
  }

  bbox = bbox.split(",");

  for (var i = 0; i < bbox.length; ++i) {
    bbox[i] = parseFloat(bbox[i]);
  }

  return {
    x: bbox[3] - bbox[0],
    y: bbox[4] - bbox[1],
    z: bbox[5] - bbox[2],
    cx: (bbox[3] + bbox[0]) / 2,
    cy: (bbox[4] + bbox[1]) / 2,
    cz: (bbox[5] + bbox[2]) / 2,
  };
};

Sculpteo3DViewer.prototype.setAge = function (age) {
  this.$jself.Sculpteo3DViewer({ age: age });
};

Sculpteo3DViewer.prototype.setZoom = function (zoom) {
  this.$jself.Sculpteo3DViewer({ zoom: zoom });
};

Sculpteo3DViewer.prototype.setPan = function (pan) {
  this.$jself.Sculpteo3DViewer({ pan: pan });
};

Sculpteo3DViewer.prototype.getZoom = function () {
  var data = this.$jself.data("viewer");

  if (!data["options"] || !data["options"]["zoom"]) {
    return 1.2;
  }

  return data["options"]["zoom"];
};

Sculpteo3DViewer.prototype.getCutAxis = function () {
  var data = this.$jself.data("viewer");
  if (!data["options"] || !data["options"]["cutAxis"]) {
    return null;
  }
  return data["options"]["cutAxis"];
};

Sculpteo3DViewer.prototype.getPan = function () {
  var data = this.$jself.data("viewer");

  if (
    !data["options"] ||
    !data["options"]["panx"] ||
    !data["options"]["pany"]
  ) {
    return { x: 0.0, y: 0.0 };
  }

  return { x: data["options"]["panx"], y: data["options"]["pany"] };
};

Sculpteo3DViewer.prototype.getQuality = function () {
  var data = this.$jself.data("viewer");
  if (!data["options"] || !data["options"]["quality"]) {
    // default to best and most used quality
    return 2;
  }
  return data["options"]["quality"];
};

Sculpteo3DViewer.prototype.setQuality = function (quality) {
  this.$jself.Sculpteo3DViewer({ quality: quality });
};

Sculpteo3DViewer.prototype.setRemoteQuality = function (remote_quality) {
  this.$jself.Sculpteo3DViewer({ remote_quality: remote_quality });
};

Sculpteo3DViewer.prototype.enablePatchRender = function () {
  var data = this.$jself.data("viewer");

  this.$jself.Sculpteo3DViewer({ patch_render: 1 });
  if (
    data["options"]["patch_width"] == 0 ||
    data["options"]["patch_width"] == false
  ) {
    this.$jself.Sculpteo3DViewer({ patch_width: 64 }); // Maybe set a define for the default size
  }
  if (
    data["options"]["patch_height"] == 0 ||
    data["options"]["patch_height"] == false
  ) {
    this.$jself.Sculpteo3DViewer({ patch_height: 64 }); // Maybe set a define for the default size
  }
};

Sculpteo3DViewer.prototype.disablePatchRender = function () {
  this.$jself.Sculpteo3DViewer({ patch_render: 0 });
};

Sculpteo3DViewer.prototype.setPatchRender = function (patch_render) {
  var data = this.$jself.data("viewer");

  if (patch_render == 1 || patch_render == true) {
    this.$jself.Sculpteo3DViewer({ patch_render: 1 });
    if (
      data["options"]["patch_width"] == 0 ||
      data["options"]["patch_width"] == false
    ) {
      this.$jself.Sculpteo3DViewer({ patch_width: 64 }); // Maybe set a define for the default size
    }
    if (
      data["options"]["patch_height"] == 0 ||
      data["options"]["patch_height"] == false
    ) {
      this.$jself.Sculpteo3DViewer({ patch_height: 64 }); // Maybe set a define for the default size
    }
  } else if (patch_render == 0 || patch_render == false) {
    this.$jself.Sculpteo3DViewer({ patch_render: 0 });
  } else {
    console.error("error: invalid parameter, expected a boolean value.");
  }
};

Sculpteo3DViewer.prototype.setPatchFillType = function (fill_type) {
  this.$jself.Sculpteo3DViewer({ patch_fill_type: fill_type });
};

Sculpteo3DViewer.prototype.setPatchFrequency = function (frequency) {
  this.$jself.Sculpteo3DViewer({ patch_frequency: frequency });
};

Sculpteo3DViewer.prototype.setPatchWidth = function (p_w) {
  this.$jself.Sculpteo3DViewer({ patch_width: p_w });
};

Sculpteo3DViewer.prototype.setPatchHeight = function (p_h) {
  this.$jself.Sculpteo3DViewer({ patch_height: p_h });
};

Sculpteo3DViewer.prototype.setPatchSize = function (p_w, p_h) {
  this.$jself.Sculpteo3DViewer({ patch_width: p_w });
  this.$jself.Sculpteo3DViewer({ patch_height: p_h });
};

Sculpteo3DViewer.prototype.getPatchRender = function () {
  var data = this.$jself.data("viewer");
  return data["options"]["patch_render"];
};

Sculpteo3DViewer.prototype.getPatchFillType = function () {
  var data = this.$jself.data("viewer");
  return data["options"]["patch_fill_type"];
};

Sculpteo3DViewer.prototype.getPatchFrequency = function () {
  var data = this.$jself.data("viewer");
  return data["options"]["patch_frequency"];
};

Sculpteo3DViewer.prototype.getPatchWidth = function () {
  var data = this.$jself.data("viewer");
  return data["options"]["patch_width"];
};

Sculpteo3DViewer.prototype.getPatchHeight = function () {
  var data = this.$jself.data("viewer");
  return data["options"]["patch_height"];
};

Sculpteo3DViewer.prototype.getPatchSize = function () {
  var data = this.$jself.data("viewer");
  var patch_size = [
    data["options"]["patch_width"],
    data["options"]["patch_height"],
  ];
  return patch_size;
};

Sculpteo3DViewer.prototype.setSmoothNormals = function (enable) {
  this.$jself.Sculpteo3DViewer({ smooth_normals: enable });
};

Sculpteo3DViewer.prototype.setTranslucency = function (translucency) {
  this.$jself.Sculpteo3DViewer({ translucency: translucency });
};

Sculpteo3DViewer.prototype.setBumpNoise = function (noise) {
  this.$jself.Sculpteo3DViewer({ bumpnoise: noise });
};

Sculpteo3DViewer.prototype.setGaussNoise = function (noise) {
  this.$jself.Sculpteo3DViewer({ gaussian_amplitude: noise });
};

Sculpteo3DViewer.prototype.setSolidity = function (min, max) {
  this.$jself.Sculpteo3DViewer({ solidity: [min, max] });
};

Sculpteo3DViewer.prototype.setSliced = function (dx, dy, dz) {
  this.$jself.Sculpteo3DViewer({ sliced: [dx, dy, dz] });
};

Sculpteo3DViewer.prototype.setEnvmap = function (url) {
  this.$jself.Sculpteo3DViewer({ envmap: url });
};

Sculpteo3DViewer.prototype.setForceNodeMap = function (enable) {
  this.$jself.Sculpteo3DViewer({ forceNodeMap: enable });
};

Sculpteo3DViewer.prototype.setRenderCache = function (enable) {
  this.$jself.Sculpteo3DViewer({ rendercache: enable });
};

Sculpteo3DViewer.prototype.setTexture = function (texture, index) {
  this.$jself.Sculpteo3DViewer({
    texture: [{ texture: texture, index: index }],
  });
};

Sculpteo3DViewer.prototype.getStatusMessage = function () {
  return this._statusMessage;
};

// Show a status message in the viewer
Sculpteo3DViewer.prototype.setStatusMessage = function (
  message,
  throbber,
  progress,
  className
) {
  this._statusMessage = message;

  var data = this.$jself.data("viewer");
  var local = this.$jself.data("localSettings") || {};

  if (!data.uiStatusLayer) {
    var options = $.extend(
      {
        font: "arial",
        textHeight: 14,
        text: "",

        // TextColor: { r:255, g:255, b:255, a:255 }
        textColor: { r: 128, g: 128, b: 128, a: 255 },
      },
      local.label
    );

    // Create the UI
    data.uiStatusAnimationImage = this.createImage(
      STATIC_URL + "css/images/loader_anim_gray_16.png"
    );
    data.uiStatusLabel = this.createUILabel(options);

    data.uiStatusThrobber = this.createUIThrobber({
      animationImage: data.uiStatusAnimationImage,
      animationFrames: 12,
      fps: 12,
    });

    data.uiStatusLayer = this.createUILayer({
      borderRadius: 4,
      backgroundColor: { r: 0, g: 0, b: 0, a: 0 },
    });

    data.uiStatusProgress = this.createUILayer({
      borderRadius: 4,
      backgroundColor: { r: 106, g: 164, b: 245, a: 255 },
    });
    data.uiStatusProgress.setFrame(0, 0, 0, 20);

    data.uiStatusLayer.setFrame(0, 0, 220, 20);
    data.uiStatusThrobber.setFrame(data.uiStatusLayer.frame.w - 20, 2, 16, 16);
    data.uiStatusLayer.appendChild(data.uiStatusProgress);
    data.uiStatusLayer.appendChild(data.uiStatusLabel);
  }

  // Enable or disable throbber
  if (throbber) {
    data.uiStatusLayer.appendChild(data.uiStatusThrobber);
    data.uiStatusThrobber.start();
  } else {
    data.uiStatusThrobber.detach();
  }

  if (progress) {
    data.uiStatusProgress.setFrame(0, 0, 220 * progress, 20);
  } else {
    data.uiStatusProgress.setFrame(0, 0, 0, 20);
  }

  // Set text
  data.uiStatusLabel.setText(message);
  // Set Class
  if (className) {
    data.uiStatusLayer.addClass(className);
  }

  // Recenter the label
  data.uiStatusLabel.setFrame(
    (data.uiStatusLayer.frame.w - data.uiStatusLabel.frame.w) / 2,
    2
  );

  // Center the status message
  data.uiStatusLayer.setFrame(
    (this.getWidth() - data.uiStatusLayer.frame.w) * 0.5,
    this.getHeight() - 20 - 8,
    220,
    20
  );

  // Cancel fade out animation
  if (data.uiStatusLayerAnimation) {
    data.uiStatusLayerAnimation.cancel();
    delete data.uiStatusLayerAnimation;
  }

  // Make sure opacity is reset
  data.uiStatusLayer.setOpacity(1.0);

  // Add to root
  if (!data.uiStatusLayer.parentLayer) {
    this.getRootLayer().appendChild(data.uiStatusLayer);
  }
};

// Clear status message with a fade out animation
Sculpteo3DViewer.prototype.clearStatusMessage = function () {
  this._statusMessage = "";

  var data = this.$jself.data("viewer");

  if (data.uiStatusLayer) {
    data.uiStatusThrobber.stop();
    data.uiStatusThrobber.detach();
    data.uiStatusLayerAnimation = data.uiStatusLayer.fadeOut(500, function () {
      data.uiStatusLayer.detach();
      delete data.uiStatusLayerAnimation;
    });
  }
};

Sculpteo3DViewer.prototype.setShowInternalLoadMessages = function (enable) {
  var data = this.$jself.data("viewer");

  data["options"]["show_load_messages"] = enable;
};

Sculpteo3DViewer.prototype.showHoleFeature = function () {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.showHoleFeature) {
    viewerInstance.showHoleFeature({ color: { r: 255, g: 0, b: 255, a: 255 } });
  }
};

Sculpteo3DViewer.prototype.hideHoleFeature = function () {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.showHoleFeature) {
    viewerInstance.showHoleFeature({
      color: { r: 255, g: 255, b: 255, a: 255 },
    });
  }
};

Sculpteo3DViewer.prototype.showEnclosedFeature = function () {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.showEnclosedFeature) {
    viewerInstance.showEnclosedFeature({
      color: { r: 255, g: 0, b: 0, a: 255 },
    });
  }
};

Sculpteo3DViewer.prototype.hideEnclosedFeature = function () {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.showEnclosedFeature) {
    viewerInstance.showEnclosedFeature({
      color: { r: 255, g: 255, b: 255, a: 255 },
    });
  }
};

Sculpteo3DViewer.prototype.activateGroupPicking = function (
  node,
  onClick,
  onHover
) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.activateGroupPicking) {
    if (node) {
      var markups = viewerInstance.activateGroupPicking(
        node.instance,
        onClick,
        onHover
      );
    }
  }
};
Sculpteo3DViewer.prototype.deactivateGroupPicking = function (node) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.deactivateGroupPicking) {
    if (node) {
      var markups = viewerInstance.deactivateGroupPicking(node.instance);
    }
  }
};

Sculpteo3DViewer.prototype.deactivateFeaturePicking = function (node) {
  if (!node) {
    var node = this.getNodesByName("model")[0];
  }
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.deactivateFeaturePicking) {
    var markups = viewerInstance.deactivateFeaturePicking(node);
  }
};
Sculpteo3DViewer.prototype.activateFunctionalFeaturePicking = function (
  featureHover,
  featureClick,
  selectedMap,
  node
) {
  if (!node) node = this.getNodesByName("model")[0];
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.activateFeaturePicking) {
    var markups = viewerInstance.activateFeaturePicking(
      node,
      featureHover,
      featureClick,
      true,
      true,
      selectedMap
    );
  }
};
Sculpteo3DViewer.prototype.activateFeaturePicking = function () {
  var node = this.getNodesByName("model")[0];
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.activateFeaturePicking) {
    var markups = viewerInstance.activateFeaturePicking(node);
  }
  //data.uiHelpLayer.setFrame(this.getWidth() - 100, 12);
  //var markupHeight = 30;
  //var markupLength = 180;
  //var markupLayer = this.createUILayer({
  //frame: {x: 0, y: 0, w:markupLength,
  //h:this.getHeight()}
  //});
  //var pos = 0;
  //var len = markups ? markups.length : 0;
  //for(var i = 0; i < len; i++){
  //var text = "";
  //console.log(markups[i]);
  //for(var j = 0; j < markups[i].text.length; j++){
  //text += markups[i].text[j];
  //}
  //if(!text) continue;
  //var idx = [];
  //for(var j = 0; j < markups[i].n_marked; j++){
  //if(markups[i].marked[j].type == 1)
  //idx.push(markups[i].marked[j].id);
  //}
  ////console.log(markups[i]);
  //var markupBtn = this.createUIButton({
  //text: text,
  //textHeight: 10,
  //frame: {
  //x:0,
  //y: pos*markupHeight,
  //w: markupLength,
  //h: markupHeight
  //},
  //});i
  //markupBtn.setFrame(0, pos*markupHeight);
  //var f = function(_idx){
  //markupBtn.addEventListener("mouseenter", function(){
  //viewerInstance.canUpdate = false;
  //viewerInstance.setVbosColorFromIdx(_idx,
  //{color:{r:0, g:255, b:255, a:255}});
  //});
  //markupBtn.addEventListener("mouseleave", function(){
  //viewerInstance.canUpdate = true;
  //viewerInstance.setVbosColorFromIdx(_idx,
  //{color:{r:255, g:255, b:255, a:255}});
  //});
  //};
  //f(idx);
  //pos += 1;
  ////console.log(markupBtn);
  //markupLayer.appendChild(markupBtn);
  //}
  //this.getRootLayer().appendChild(markupLayer);
};

Sculpteo3DViewer.prototype.deactivateOverhang = function (node) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.deactivateOverhang) {
    viewerInstance.deactivateOverhang(node);
  }
};

Sculpteo3DViewer.prototype.activateOverhang = function (
  node,
  default_color,
  overhang_face_color,
  overhang_vertex_color,
  overhang_vertex_point_size,
  support_color
) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.activateOverhang) {
    if (!overhang_face_color) {
      overhang_face_color = [0.8, 0.1, 0.1];
    }
    if (!overhang_vertex_color) {
      overhang_vertex_color = [0.1, 0.1, 0.8];
    }
    if (!default_color) {
      default_color = [0.1, 0.8, 0.1];
    }
    if (!overhang_vertex_point_size) {
      overhang_vertex_point_size = 3;
    }
    if (!support_color) {
      support_color = [1, 0.9, 0.6];
    }
    viewerInstance.activateOverhang(
      node,
      default_color,
      overhang_face_color,
      overhang_vertex_color,
      overhang_vertex_point_size,
      support_color
    );
  }
};

Sculpteo3DViewer.prototype.showGroup = function (node, f) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.showGroup) {
    viewerInstance.showGroup(node, f);
  }
};

Sculpteo3DViewer.prototype.hideGroup = function (node, f) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.hideGroup) {
    viewerInstance.hideGroup(node, f);
  }
};

Sculpteo3DViewer.prototype.setGroupColor = function (node, f) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.setGroupColor) {
    viewerInstance.setGroupColor(node, f);
  }
};

Sculpteo3DViewer.prototype.resetGroupColor = function (node) {
  var viewerInstance = this._getViewerInstance();
  if (viewerInstance.resetGroupColor) {
    viewerInstance.resetGroupColor(node);
  }
};

// Execute a design script
Sculpteo3DViewer.prototype.exec = function (script, context, id) {
  var mesh = {
    v: [],
    f: [],
    face_mi: [],
    face_flag: [],
  };
  var worker_data = {
    id: (Math.random() * 0xffffffff) | 0,
    mesh: mesh,
    context: {},
    script: script,
    dfd: $.Deferred(),
  };
  var viewer = this;

  // Unrolls the subtree returned from worker to a scene subtree
  // creating mesh and CSG nodes on the fly
  var unroll = function (n, node) {
    if (node.operation) {
      // Generate a random id for node names
      var uuid = "exec";

      for (var i = 0; i < 32; i++) {
        uuid += ((Math.random() * 16) | 0).toString(16);
      }

      var A = viewer.createNode(uuid + "A");
      var B = viewer.createNode(uuid + "B");

      unroll(A, node.A);
      unroll(B, node.B);
      n.appendChild(A);
      n.appendChild(B, node.operation);
    } else {
      if (node.v.length != 0) {
        json = JSON.stringify(node);
        viewer.loadModel(json, n.id);
      }
    }
  };

  // Determine the node on which the script is applied
  if (typeof id == "object") {
    // Assume 2nd argument is a node already
    worker_data.root = id;
  } else {
    // Assume 2nd argument is an id
    var nodes = viewer.getNodesByName(id);

    if (nodes.length) {
      worker_data.root = nodes[0];
    } else {
      // Default to the model node
      worker_data.root = viewer.getNodesByName("model")[0];
    }
  }

  var status = null;

  if (typeof this.worker == "undefined") {
    this.worker = new Worker(STATIC_URL + "js/sculpteo3DViewerWorker.js");
    this.worker_queue = {};
  }

  this.worker.onmessage = function (message) {
    status = JSON.parse(message.data);

    var wd = viewer.worker_queue[status.id];

    clearTimeout(wd.timeout);
    delete viewer.worker_queue[status.id];

    // Log((+ new Date()) + 'worker done');
    try {
      // Log(status);
      if (typeof status.message != "undefined") {
        Utils.popupMessage(status.message, "hint"); // This may not be a hint, will need to double check that all messages qualify
      }

      if (typeof status.root == "object") {
        var tree = status.root;

        unroll(wd.root, tree);
        log(wd.root);
        wd.dfd.resolve(wd.root);
      } else {
        wd.dfd.reject();
      }
    } catch (e) {
      log("ERROR: " + e);
    }
  };

  worker_data.timeout = setTimeout(function () {
    log("timeout while executing:");
    log(worker_data);

    // Abort the worker
    viewer.worker.terminate();

    // Remove the bad script
    delete viewer.worker_queue[worker_data.id];

    // Restart the worker
    this.worker = new Worker(STATIC_URL + "js/sculpteo3DViewerWorker.js");

    // Restart all other scripts
    for (var k in viewer.worker_queue) {
      viewer.worker.postMessage(JSON.stringify(viewer.worker_queue[k]));
    }
  }, 30000);

  this.worker_queue[worker_data.id] = worker_data;
  this.worker.postMessage(
    JSON.stringify({
      id: worker_data.id,
      script: worker_data.script,
      context: worker_data.context,
      mesh: worker_data.mesh,
    })
  );

  // Log((+ new Date()) + 'worker started');

  return worker_data.dfd.promise();
};

Sculpteo3DViewer.prototype.createColorCube = function (scale, r, g, b, id) {
  var s = 0.5 * scale;
  var d = {
    v: [
      -s,
      -s,
      -s,
      -s,
      -s,
      s,
      -s,
      s,
      -s,
      -s,
      s,
      s,
      s,
      -s,
      -s,
      s,
      -s,
      s,
      s,
      s,
      -s,
      s,
      s,
      s,
    ],
    f: [
      0, 6, 4, 0, 2, 6, 0, 3, 2, 0, 1, 3, 2, 7, 6, 2, 3, 7, 4, 6, 7, 4, 7, 5, 0,
      4, 5, 0, 5, 1, 1, 5, 7, 1, 7, 3,
    ],
    face_flag: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    face_mi: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    material: [{ color: { r: r, g: g, b: b } }],
  };

  this.loadModel(JSON.stringify(d), id);
};

Sculpteo3DViewer.prototype.unbind = function (event, listener) {
  var data = this.$jself.data("handler");

  if (!data) {
    return;
  }

  if (!data[event]) {
    return;
  }
  if (listener) {
    var i = data[event].indexOf(listener);
    if (i != -1) {
      data[event].splice(i, 1);
      return this;
    }
  }
  delete data[event];

  return this;
};

Sculpteo3DViewer.prototype.bind = function (event, f) {
  var data = this.$jself.data("handler");

  if (!data) {
    this.$jself.data("handler", {});
    data = this.$jself.data("handler");
  }

  if (!data[event]) {
    data[event] = [];
  }

  data[event].push(f);

  return this;
};

Sculpteo3DViewer.prototype.drawLine = function (
  lineObjectHandle,
  Ax,
  Ay,
  Bx,
  By,
  lineImgPath
) {
  /*
   *	LineObjectHandle = an IMG tag with position:absolute
   */
  var xMin = Math.min(Ax, Bx),
    yMin = Math.min(Ay, By),
    xMax = Math.max(Ax, Bx),
    yMax = Math.max(Ay, By),
    boxWidth = Math.max(xMax - xMin, 1),
    boxHeight = Math.max(yMax - yMin, 1),
    tmp = Math.min(boxWidth, boxHeight),
    smallEdge = 1,
    newSrc;

  while ((tmp >>= 1)) {
    smallEdge <<= 1;
  }

  newSrc =
    lineImgPath +
    smallEdge +
    ((Bx - Ax) * (By - Ay) < 0 ? "up.gif" : "down.gif");
  var currentSrc = lineObjectHandle.attr("src");

  if (!currentSrc || currentSrc.indexOf(newSrc) == -1) {
    lineObjectHandle.attr("src", newSrc);
  }

  lineObjectHandle
    .css({
      width: boxWidth + "px",
      height: boxHeight + "px",
      left: xMin + "px",
      top: yMin + "px",
    })
    .show();
};

// Set the callback function to call when nodes are selected.
Sculpteo3DViewer.prototype.setOnSelectNode = function (callback) {
  Sculpteo3DViewer.prototype.onSelectNode = callback;
};

Sculpteo3DViewer.prototype.waitOnJobs = function (url, id) {
  var data = this.$jself.data("viewer");
  if (typeof id == "undefined") {
    id = "model";
  }

  var load = {};
  load[id] = url;

  return this.$jself.Sculpteo3DViewer(
    "waitonjobs",
    { load: load },
    data["viewerTech"]
  );
};

Sculpteo3DViewer.prototype.hideViewerFilesScreen = function (url, id) {
  return this.$jself.Sculpteo3DViewer("hideViewerFilesScreen");
};

Sculpteo3DViewer.prototype.showViewerFilesScreen = function (url) {
  return this.$jself.Sculpteo3DViewer("showViewerFilesScreen", url);
};

(function ($) {
  var methods = {
    init: function (settings) {
      return this.each(function () {
        var $this = $(this),
          data = $this.data("viewer"),
          local = $this.data("localSettings") || {};

        if (data && (data["viewerInited"] || data["waiting_jobs"])) {
          return $this.Sculpteo3DViewer("options", settings);
        }

        $this.addClass("Sculpteo3DViewer");
        var defaults = {
          material: "white_plastic",
          bgcolor: [239, 241, 243],
          selcolor: [0, 0, 255, 220],
          cutColor: [1.0, 0.0, 0.0, 0.01],
          cutAxis: null,
          doubleCut: undefined,
          transform: "1,0,0,0",
          zoom: 1.2,
          local: false,
          autorotate: false,
          wireframe: false,
          csgmode: Sculpteo3DViewer.CSG_MODE_NONE,
          perspective: false,
          pointcloud: false,
          orientation: false,
          resetview: false,
          issues: 0,
          selectedfaces: false,
          showhelp: true,
          fading: true,
          bgImage: "",
          unitmm: 0.0,
          mview_jnlp: URLS["mview_jnlp"],
          fonturl: URLS["x_font_model"],
          render: URLS["render"],
          new_scene_url: URLS["new_scene_url"],
          rendertimeout: Sculpteo3DViewerRenderTimeout,
          rendersize: "4096,4096",
          patch_render: false,
          patch_width: false,
          patch_height: false,
          patch_fill_type: false,
          patch_frequency: false,
          remote_quality: false,
          quality: 2,
          smooth_normals: false,
          translucency: 0,
          bumpnoise: "",
          min_solidity: -1.0,
          max_solidity: -1.0,
          envmapurl: "",
          envmap: false,
          forceNodeMap: false,
          show_viewer_select: true,
          rendercache: false,
          uuid: "",
          update_geometry: true,
          update_material: true,
          show_load_messages: true,
          age: 0,
        };
        var options = $.extend({}, defaults, settings, local);

        Sculpteo3DViewerDetectCaps();
        var viewerTech = Sculpteo3DViewerTech;

        if (
          viewerTech == "webgl" &&
          !(Sculpteo3DViewerCaps & Sculpteo3DViewerCap_webgl)
        ) {
          Sculpteo3DViewerTechInit = Sculpteo3DViewerTech = viewerTech = "auto";
        }

        if (
          viewerTech == "static" &&
          !(Sculpteo3DViewerCaps & Sculpteo3DViewerCap_static)
        ) {
          Sculpteo3DViewerTechInit = Sculpteo3DViewerTech = viewerTech = "auto";
        }

        if (viewerTech == "auto") {
          /* Prefer WebGL over Flash over Java over JS */
          if (Sculpteo3DViewerCaps & Sculpteo3DViewerCap_webgl) {
            viewerTech = "webgl";
          } else if (Sculpteo3DViewerCaps & Sculpteo3DViewerCap_static) {
            viewerTech = "static";
          } else {
            viewerTech = "";
          }
        }

        // Backward compatibility for options.load as a string
        if (typeof options.load == "string") {
          options.load = { model: options.load };
        }

        /* Wait for files */
        if (options.src && options.src.depend_on_jobs) {
          return $this.Sculpteo3DViewer("waitonjobs", options, viewerTech).done(
            function () {
              $this.Sculpteo3DViewer(options);
            }.bind(this)
          );
        }

        if (options.load && Object.keys(options.load).length == 1) {
          for (var id in options.load) {
            if (options.load[id].depend_on_jobs) {
              return $this
                .Sculpteo3DViewer("waitonjobs", options, viewerTech)
                .done(
                  function () {
                    $this.Sculpteo3DViewer(options);
                  }.bind(this)
                );
            }
          }
        }

        var viewerId = Sculpteo3DViewerId++;

        // Make the event handler a global variable, for easier calls from Java and Flash
        var eventHandler = (window["Sculpteo3DViewerEventHandler" + viewerId] =
          new Sculpteo3DViewerEventHandler($this, options.eventhandler));

        options._eventhandler = eventHandler;
        options.eventhandlerName = "Sculpteo3DViewerEventHandler" + viewerId;

        if (options.src && getModelSrc(options.src, viewerTech) == null) {
          viewerTech = "static";
        }

        var d = $.extend(data, {});

        delete d.viewer;
        d = $.extend(d, {
          viewerTech: viewerTech,
          viewerInited: true,
          viewerLoaded: false,
          viewerReady: false,
          viewerPending: [],
          options: options,
          viewerId: viewerId,
          eventHandler: eventHandler,
        });

        $this.data("viewer", d);

        // Clear stale status message
        var viewer = $this.Sculpteo3DViewer();

        viewer.clearStatusMessage();

        if (viewerTech == "webgl") {
          // Uncomment to enable webgl debugging
          // require(["webgl-debug"], function() {
          $this.Sculpteo3DViewerWebGL(viewerId, options);

          // });
        } else if (viewerTech == "static") {
          $this.Sculpteo3DViewerStatic(viewerId, options);
        } else {
          $this.data("viewer", {
            viewerTech: viewerTech,
            viewerInited: true,
            viewerLoaded: true,
            viewerPending: [],
            viewerReady: false,
            options: options,
            viewerId: viewerId,
          });
          $this.html(
            String.format(gettext("JAVA_NOT_PRESENT"), URLS["preferences"])
          );
        }
      });
    },

    hideViewerFilesScreen: function () {
      var $this = $(this);
      var data = $this.data("viewer");
      var loaded = data && data["viewerLoaded"];
      if (data["waiting_jobs"]) {
        $(".module-loading", $this.parent("._3dPanel")).hide();
        if (!loaded) {
          viewer.html("");
        } else {
          $(".tech3d").show();
          $(".module-remotectrl", $this.parent("._3dPanel")).show();
          $(".viewerfiles", viewer).remove();
        }
        data["waiting_jobs"] = false;
        $this.data("viewer", data);
      }
    },

    showViewerFilesScreen: function (model_src) {
      var viewer = $(this);
      var data = viewer.data("viewer");
      var loaded = data && data["viewerLoaded"];
      if (!data) {
        data = [];
      }
      data["waiting_jobs"] = true;
      if (!data["viewerPending"]) {
        data["viewerPending"] = [];
      }
      viewer.data("viewer", data);

      $(".tech3d").hide();
      $(".module-loading", viewer.parent("._3dPanel")).show();
      $(".module-remotectrl", viewer.parent("._3dPanel")).hide();

      var $d = $(
        '<div class="viewerfiles hide_in_fabpilot" style="position: absolute; left: 25%; opacity: 0.1; bottom: 40%; width: 50%; text-align: center; font-weight: bold">' +
          gettext("Generating files") +
          "</div>"
      );
      var $progress = $(
        '<div class="viewerfiles hide_in_fabpilot" style="position: absolute; left: 25%; opacity: 0.1; top: 60%; height: 24px; width: 50%; text-align: center; border: 1px solid black; border-radius: 4px; background-color: transparent"></div>'
      );
      var $progressbar = $(
        '<div class="viewerfiles_progress hide_in_fabpilot" style="width: 0%; height: 100%; background-color: #1C97EC"></div>'
      );

      $progress.append($progressbar);

      var tmp_img_id = Math.floor(Math.random() * 1024);

      var $img = null;
      if (model_src.image) {
        var image = new Image();
        image.src = model_src.image;
        image.onload = function () {
          var img = $("#tmp_img_" + tmp_img_id);

          if (image.width / image.height < viewer.width() / viewer.height()) {
            img.width((image.width * viewer.height()) / image.height);
            img.height(viewer.height());
          } else {
            img.height((image.height * viewer.width()) / image.width);
            img.width(viewer.width());
          }

          img.css(
            "margin",
            (viewer.height() - img.height()) / 2 +
              "px " +
              (viewer.width() - img.width()) / 2 +
              "px"
          );
        };
        if (!loaded) {
          viewer.html("");
        }
        $img = $(
          '<div class="viewerfiles" style="float: left; position: relative; width:' +
            viewer.width() +
            "px; height: " +
            viewer.height() +
            'px">' +
            '<img id="tmp_img_' +
            tmp_img_id +
            '" class="fleft" src="' +
            model_src.image +
            '"/>'
        );
        if (viewer.find(" > div").length) {
          viewer.find(" > div").append($img);
          viewer.find(" > div").append($d);
          viewer.find(" > div").append($progress);
        } else {
          viewer.append($img);
          viewer.append($d);
          viewer.append($progress);
        }
      } else {
        viewer.append($d);
        viewer.append($progress);
      }

      $d.animate({ opacity: "1" }, 4000)
        .animate({ opacity: "0.2" }, 4000)
        .animate({ opacity: "1" }, 4000)
        .animate({ opacity: "0.2" }, 4000)
        .animate({ opacity: "1" }, 4000);
    },

    waitonjobs: function (options, viewerTech) {
      var wait_dfd = $.Deferred();
      var $this = $(this);

      var viewer = $this;

      var model_src = options.src;

      if (!model_src || !model_src.depend_on_jobs) {
        model_src = null;
        if (options.load) {
          for (var id in options.load) {
            model_src = options.load[id];
            break;
          }
        }
      }

      if (!model_src) {
        return;
      }

      $this.Sculpteo3DViewer("showViewerFilesScreen", model_src);

      var viewer_started = false;
      var start_viewer = function () {
        if (!viewer_started) {
          viewer_started = true;
          $(".module-loading", $this.parent("._3dPanel")).hide();
          var data = $this.data("viewer");
          var loaded = data && data["viewerLoaded"];
          if (!loaded) {
            viewer.html("");
          } else {
            $(".tech3d").show();
            $(".module-remotectrl", $this.parent("._3dPanel")).show();
            $(".viewerfiles", viewer).remove();
          }
          var waiting_jobs = data["waiting_jobs"];
          data["waiting_jobs"] = false;
          $this.data("viewer", data);
          wait_dfd.resolve(options);
        }
      };

      var process_msg = function (msg) {
        // Log("process msg");
        // log(msg);
        viewer.find(".viewerfiles_progress").css({ width: msg.percent + "%" });

        if (msg.webgl) {
          model_src.webgl = msg.webgl;

          if (viewerTech == "webgl") {
            start_viewer();
          }
        }

        if (msg.canvas) {
          model_src.canvas = msg.canvas;

          if (viewerTech == "static") {
            start_viewer();
          }
        }

        if (msg.image) {
          model_src.image = msg.image;
        }
      };
      if (model_src.depend_on_jobs) {
        $.get(model_src.depend_on_jobs).done(function (jobs) {
          delete model_src.depend_on_jobs;

          // Log("jobs");
          // log(jobs);
          if (jobs && jobs.length) {
            sculpteoJob(jobs)
              .progress(function (job, msg) {
                process_msg(msg);
              })
              .success(function (job, msg) {
                process_msg(msg);
                $(".tech3d").show();
              });
          } else {
            process_msg(model_src);
            wait_dfd.resolve(options);
          }
        });
      } else {
        wait_dfd.resolve(options);
      }
      return wait_dfd.promise();
    },

    loadViewer: function (viewerTech) {
      return this.each(function () {
        var data = $(this).data("viewer");

        if (
          !data ||
          data["viewerTech"] != viewerTech ||
          data["viewer"] ||
          $(this).data("viewerLoading")
        ) {
          return;
        }

        $(this).data("viewerLoading", true);
        var viewerId = data["viewerId"],
          options = data["options"] ? data["options"] : null;
        var viewer = $(this).Sculpteo3DViewer();

        // Backward compatibility for options.load as a string
        if (typeof options.load == "string") {
          options.load = { model: options.load };
        }

        if (options.show_load_messages) {
          if (options.src || (options.load && options.load["model"])) {
            viewer.setStatusMessage(gettext("Loading 3D model"), true, 0);
          }
        }

        var o = $.extend({}, options);

        if (typeof o.load != "undefined") {
          if (!o.load["model"] && o.src) {
            o.load["model"] = o.src;
          }

          delete o.src;
        }

        switch (viewerTech) {
          case "static":
            data["viewer"] = new Sculpteo3DViewerStatic($(this), viewerId, o);
            break;
          case "webgl":
            try {
              data["viewer"] = new Sculpteo3DViewerWebGL($(this), viewerId, o);
            } catch (e) {
              Sculpteo3DViewerTech = "static";
              Sculpteo3DViewerTechInit = "static";
              data["viewer"] = new Sculpteo3DViewerStatic($(this), viewerId, o);
              if (window.topbar) window.topbar.notify(e.msg, "error");
            }
            break;
        }

        $(this).data("viewer", data);
        $(this).data("viewerLoading", false);
      });
    },

    options: function (options) {
      if (options === null) {
        return;
      }
      return this.each(function () {
        var $this = $(this),
          data = $this.data("viewer");

        //avoid js error on new print. Don't really know why the options are not ready when we are coming from a multi print
        //No issue when coming from a basic 3D print
        if (typeof data["options"] == "undefined") {
          return;
        }

        if (
          typeof options.age != "undefined" &&
          typeof data["options"].age != "undefined"
        ) {
          if (options.age < data["options"].age) {
            data["options"]._eventhandler("discard");

            return;
          }
        }

        data["options"] = $.extend(true, data["options"], options);

        if (typeof options.load == "string") {
          options.load = { model: options.load };
        }

        $this.data("viewer", data);
        var viewer = data["viewer"];

        if (
          !$.isEmptyObject(options) &&
          data["viewerLoaded"] &&
          viewer.lockDisplay
        ) {
          viewer.lockDisplay(true);

          // Log("process options");

          if (options.fading != null) {
            viewer.setFading(options.fading);
          }

          if (options.src != null) {
            if (options.src.depend_on_jobs) {
              return $this
                .Sculpteo3DViewer(
                  "waitonjobs",
                  data["options"],
                  data["viewerTech"]
                )
                .done(
                  function () {
                    $this.Sculpteo3DViewer(data["options"]);
                  }.bind(this)
                );
            }

            if (!viewer.loaded_url) {
              viewer.loaded_url = {};
            }

            viewer.loaded_url["model"] = getModelSrc(
              options.src,
              data["viewerTech"]
            );
            if (options.show_load_messages) {
              $this
                .Sculpteo3DViewer()
                .setStatusMessage(gettext("Loading 3D model"), true, 0);
            }
            viewer.loadModel(viewer.loaded_url["model"]);
          }

          if (options.load != null) {
            if (!viewer.loaded_url) {
              viewer.loaded_url = {};
            }

            for (var id in options.load) {
              if (
                options.load[id] == viewer.loaded_url[id] &&
                options.update_geometry == false &&
                options.update_material == false
              ) {
                fakeLoad(this, options.load[id], function () {
                  viewer.setUpdate();
                });
              } else {
                viewer.loaded_url[id] = options.load[id];

                if (id == "model") {
                  if (options.show_load_messages) {
                    $this
                      .Sculpteo3DViewer()
                      .setStatusMessage(gettext("Loading 3D model"), true, 0);
                  }
                }

                if (options.load[id].depend_on_jobs) {
                  return $this
                    .Sculpteo3DViewer("waitonjobs", options, data["viewerTech"])
                    .done(
                      function () {
                        $this.Sculpteo3DViewer(options);
                      }.bind(this)
                    );
                }

                viewer.loadModel(viewer.loaded_url[id], id);
              }
            }
          }

          if (options.showAll) {
            viewer.showAll();
          }

          if (options.hideAll != null) {
            viewer.hideAll(options.hideAll);
          }

          if (options.loadPost != null) {
            viewer.loadModelPost(
              options.loadPost.url,
              options.loadPost.content
            );
          }

          if (options.resetview) {
            viewer.resetView();
          }

          if (options.local != null) {
            viewer.setLocal(options.local);
          }

          if (options.autorotate != null) {
            viewer.setAutorotate(options.autorotate);
          }

          if (options.toggleAutorotate) {
            viewer.toggleAutorotate();
          }

          if (options.material) {
            viewer.setMaterial(options.material);
          }

          if (options.bgcolor) {
            viewer.setBackgroundColor(
              options.bgcolor[0],
              options.bgcolor[1],
              options.bgcolor[2]
            );
          }

          if (options.selcolor) {
            viewer.setSelectionColor(
              options.selcolor[0],
              options.selcolor[1],
              options.selcolor[2],
              options.selcolor[3]
            );
          }

          if (typeof options.cutAxis !== "undefined") {
            if (options.cutAxis !== null && options.doubleCut) {
              viewer.setDoubleCut(
                options.cutAxis[0],
                options.cutAxis[1],
                options.cutAxis[2],
                options.cutAxis[3],
                options.doubleCut
              );
            } else if (options.cutAxis !== null) {
              viewer.setCutAxis(
                options.cutAxis[0],
                options.cutAxis[1],
                options.cutAxis[2],
                options.cutAxis[3]
              );
            } else {
              viewer.clrDoubleCut();
            }
          }

          if (options.cutColor) {
            if (options.cutColor.length) {
              viewer.setCutColor(
                options.cutColor[0],
                options.cutColor[1],
                options.cutColor[2],
                options.cutColor[3],
                options.cutColor[4],
                options.cutColor[5],
                options.cutColor[6]
              );
            } else {
              viewer.clrCutColor();
            }
          }

          if (options.units != null) {
            viewer.setUnits(options.units);
          }

          if (options.csgmode != null) {
            viewer.setCSGMode(options.csgmode);
          }

          if (options.perspective != null) {
            viewer.setPerspective(options.perspective);
          }

          if (options.wireframe != null) {
            viewer.setWireframe(options.wireframe);
          }

          if (options.pointcloud != null) {
            viewer.setPointCloud(options.pointcloud);
          }

          if (options.orientation != null) {
            viewer.setOrientation(options.orientation);
          }

          if (options.showhelp != null) {
            viewer.setShowHelp(options.showhelp);
          }

          if (options.issues != null) {
            viewer.setIssues(options.issues);
          }

          if (options.selectedfaces != null) {
            viewer.setSelectedFaces(options.selectedfaces);
          }

          if (options.bgImage) {
            viewer.setBackgroundImage(options.bgImage);
          }

          if (options.unsetBgImage) {
            options.bgImage = "";
            viewer.unsetBackgroundImage();
          }

          if (typeof options.set3d != "undefined") {
            viewer.setdisable3D(!options.set3d);
          }

          if (options.rotateX90 != null) {
            rotateTo(new Sculpteo3DViewer($this), rotateX90);
          }

          if (options.rotateY90 != null) {
            rotateTo(new Sculpteo3DViewer($this), rotateY90);
          }

          if (options.rotateZ90 != null) {
            rotateTo(new Sculpteo3DViewer($this), rotateZ90);
          }

          if (options.unitmm != null) {
            viewer.setUnits(options.unitmm);
          }

          if (options.transform != null) {
            viewer.setTransform(options.transform);
          }

          if (options.zoom != null) {
            viewer.setZoom(options.zoom);
          }

          if (options.pan != null) {
            viewer.setPan(options.pan.x, options.pan.y);
          }

          if (options.sceneTransform != null) {
            viewer.setSceneTransform(options.sceneTransform);
          }

          if (options.designUUID != null) {
            viewer.setDesignUUID(options.designUUID);
          }

          if (options.quality != null) {
            viewer.setQuality(options.quality);
          }

          if (options.remote_quality != null) {
            if (viewer.setRemoteQuality) {
              viewer.setRemoteQuality(options.remote_quality);
            }
          }

          if (options.patch_render != null) {
            if (viewer.setPatchRender) {
              viewer.setPatchRender(options.patch_render);
            }
          }

          if (options.patch_fill_type != null) {
            if (viewer.setPatchFillType) {
              viewer.setPatchFillType(options.patch_fill_type);
            }
          }

          if (options.patch_frequency != null) {
            if (viewer.setPatchFrequency) {
              viewer.setPatchFrequency(options.patch_frequency);
            }
          }

          if (options.patch_width != null) {
            if (viewer.setPatchWidth) {
              viewer.setPatchWidth(options.patch_width);
            }
          }

          if (options.patch_height != null) {
            if (viewer.setPatchHeight) {
              viewer.setPatchHeight(options.patch_height);
            }
          }

          if (options.smooth_normals != null) {
            viewer.setSmoothNormals(options.smooth_normals);
          }

          if (options.translucency != null) {
            viewer.setTranslucency(options.translucency);
          }

          if (options.bumpnoise != null) {
            viewer.setBumpNoise(options.bumpnoise);
          }

          if (
            options.gaussian_amplitude != null &&
            typeof viewer.setGaussNoise === "function"
          ) {
            viewer.setGaussNoise(options.gaussian_amplitude);
          }

          if (options.solidity) {
            viewer.setSolidity(options.solidity[0], options.solidity[1]);
          }

          if (options.sliced) {
            viewer.setSliced(
              options.sliced[0],
              options.sliced[1],
              options.sliced[2]
            );
          }

          if (options.envmap != null) {
            viewer.setEnvmap(options.envmap);
          }

          if (options.forceNodeMap != null) {
            viewer.setForceNodeMap(options.forceNodeMap);
          }

          if (options.rendercache != null) {
            viewer.setRenderCache(options.rendercache);
          }

          if (options.setTexture != null) {
            if (
              typeof options.setTexture == "object" &&
              typeof options.setTexture.length != "undefined"
            ) {
              // Array
              for (var k = 0; k < options.setTexture.length; k++) {
                viewer.setTexture(
                  options.setTexture[k].texture,
                  options.setTexture[k].index
                );
              }
            } else {
              viewer.setTexture(
                options.setTexture.texture,
                options.setTexture.index
              );
            }
          }

          viewer.lockDisplay(false);
        } else {
          data["viewerPending"].push(options);
        }
      });
    },

    selectViewer: function (tech3d) {
      return this.each(function () {
        var $this = $(this),
          data = $this.data("viewer");

        if (tech3d == data["viewerTech"]) {
          return;
        }

        $this.Sculpteo3DViewer("kill");
        $this.html("");
        Sculpteo3DViewerTechInit = Sculpteo3DViewerTech = User.tech3d = tech3d;
        $("._3dPanel  .module-remotectrl").hide();

        // Reload data, killviewer modifies it
        data = $this.data("viewer");
        $this.Sculpteo3DViewer(data["options"]);
      });
    },

    switchForOverlay: function () {
      return this.each(function () {
        var $this = $(this),
          data = $this.data("viewer");

        if (!data) {
          return;
        }

        data["previousTech3d"] = data["viewerTech3d"];
        $this.data("viewer", data);
        $this.Sculpteo3DViewer("selectViewer", "static");
      });
    },

    restoreSwitchForOverlay: function () {
      return this.each(function () {
        var $this = $(this),
          data = $this.data("viewer");
        var tech3d = data["previousTech3d"];

        if (!data || !tech3d) {
          return;
        }

        data["previousTech3d"] = null;
        $this.data("viewer", data);
        $this.Sculpteo3DViewer("selectViewer", tech3d);
      });
    },

    idle: function (enabled) {
      if (!$(this).data("viewer")) {
        return;
      }

      var viewer = $(this).data("viewer")["viewer"];
      if (viewer) {
        viewer.lockDisplay(enabled);
      }
    },

    kill: function (callback) {
      var $this = $(this),
        data = $this.data("viewer");

      if (!data) {
        if (callback) {
          callback();
        }

        return true;
      }

      var viewerTech = data["viewerTech"];

      data["viewerInited"] = false;
      if (viewerTech == "static") {
        var viewer = data["viewer"];

        // Clear the remote rendering timeouts
        if (viewer) {
          viewer.cleanUp();
        }
      } else if (viewerTech == "webgl") {
        var viewer = data["viewer"];

        // Clear the remote rendering timeouts
        if (viewer) {
          viewer.cleanUp();
        }
      }

      $this.data("viewer", data);

      var namespace = "Sculpteo3DViewer" + data["viewerId"];

      $(window).unbind("focus." + namespace);
      $(window).unbind("blur." + namespace);

      if (callback) {
        callback();
      }

      return true;
    },

    destroy: function () {
      return this.each(function () {
        var $this = $(this),
          data = $this.data("viewer");

        if (!data) {
          return;
        }

        $this.html("");
        data["viewerInited"] = false;
        data["viewerLoaded"] = false;
        data["viewerReady"] = false;
        data["viewerPending"] = [];
        $this.data("viewer", data);
      });
    },

    unbind: function (event) {
      var data = $(this).data("handler");

      if (!data) {
        return;
      }

      if (!data[event]) {
        return;
      }

      delete data[event];
    },

    bind: function (event, f) {
      var data = $(this).data("handler");

      if (!data) {
        $(this).data("handler", {});
        data = $(this).data("handler");
      }

      if (!data[event]) {
        data[event] = [];
      }

      data[event].push(f);
    },

    viewer: function () {
      if ($(this).length) {
        return new Sculpteo3DViewer($(this));
      }
    },
  };

  $.fn.Sculpteo3DViewer = function (method) {
    if (typeof method == "undefined") {
      method = "viewer";
    }

    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "Method " + method + " does not exist on jQuery.Sculpteo3DViewer"
      );
    }
  };
})(jQuery);

function rotateTo(viewer, func) {
  viewer.setAutorotate(false);

  var current = "" + viewer.getTransform();

  if (Sculpteo3DViewerTech == "static") {
    viewer.setTransform(func(current));

    return;
  }

  var t = {
    w: current.split(/,/)[0],
    x: current.split(/,/)[1],
    y: current.split(/,/)[2],
    z: current.split(/,/)[3],
  };

  var destination = func(current).split(/,/);

  var tweenW = new Tween(
    t,
    "w",
    Tween.strongEaseOut,
    current.split(/,/)[0] + 0,
    destination[0] + 0,
    0.3,
    ""
  );
  var tweenX = new Tween(
    t,
    "x",
    Tween.strongEaseOut,
    current.split(/,/)[1] + 0,
    destination[1] + 0,
    0.3,
    ""
  );
  var tweenY = new Tween(
    t,
    "y",
    Tween.strongEaseOut,
    current.split(/,/)[2] + 0,
    destination[2] + 0,
    0.3,
    ""
  );
  var tweenZ = new Tween(
    t,
    "z",
    Tween.strongEaseOut,
    current.split(/,/)[3] + 0,
    destination[3] + 0,
    0.3,
    ""
  );
  var a = new Object();

  a.onMotionChanged = function () {
    viewer.setTransform(t.w + "," + t.x + "," + t.y + "," + t.z);
  };

  tweenW.addListener(a);
  tweenW.start();
  tweenX.start();
  tweenY.start();
  tweenZ.start();
}

function rotateX90(t) {
  var G = (t + "").split(/,/);
  var gx, gy, gz, gw;

  gw = G[0];
  gx = G[1];
  gy = G[2];
  gz = G[3];

  var r = 0.707106781186548;
  var sx, sy, sz, sw;

  sw = r * gw + r * gx;
  sx = r * gx - r * gw;
  sy = r * gy + r * gz;
  sz = r * gz - r * gy;

  return sw + "," + sx + "," + sy + "," + sz;
}

function rotateX90_anti(t) {
  var G = (t + "").split(/,/);
  var gx, gy, gz, gw;

  gw = G[0];
  gx = G[1];
  gy = G[2];
  gz = G[3];

  var r = 0.707106781186548;
  var sx, sy, sz, sw;

  sw = r * gw - r * gx;
  sx = r * gx + r * gw;
  sy = r * gy - r * gz;
  sz = r * gz + r * gy;

  return sw + "," + sx + "," + sy + "," + sz;
}

function rotateY90(t) {
  var G = (t + "").split(/,/);
  var gx, gy, gz, gw;

  gw = G[0];
  gx = G[1];
  gy = G[2];
  gz = G[3];

  var r = 0.707106781186548;
  var sx, sy, sz, sw;

  sw = r * gw - r * gz;
  sx = r * gx - r * gy;
  sy = r * gy + r * gx;
  sz = r * gz + r * gw;

  return sw + "," + sx + "," + sy + "," + sz;
}

function rotateY90_anti(t) {
  var G = (t + "").split(/,/);
  var gx, gy, gz, gw;

  gw = G[0];
  gx = G[1];
  gy = G[2];
  gz = G[3];

  var r = 0.707106781186548;
  var sx, sy, sz, sw;

  sw = r * gw + r * gz;
  sx = r * gx + r * gy;
  sy = r * gy - r * gx;
  sz = r * gz - r * gw;

  return sw + "," + sx + "," + sy + "," + sz;
}

function rotateZ90(t) {
  var G = (t + "").split(/,/);
  var gx, gy, gz, gw;

  gw = G[0];
  gx = G[1];
  gy = G[2];
  gz = G[3];

  var r = 0.707106781186548;
  var sx, sy, sz, sw;

  sw = r * gw + r * gy;
  sx = r * gx - r * gz;
  sy = r * gy - r * gw;
  sz = r * gz + r * gx;

  return sw + "," + sx + "," + sy + "," + sz;
}

function rotateZ90_anti(t) {
  var G = (t + "").split(/,/);
  var gx, gy, gz, gw;

  gw = G[0];
  gx = G[1];
  gy = G[2];
  gz = G[3];

  var r = 0.707106781186548;
  var sx, sy, sz, sw;

  sw = r * gw - r * gy;
  sx = r * gx + r * gz;
  sy = r * gy + r * gw;
  sz = r * gz - r * gx;

  return sw + "," + sx + "," + sy + "," + sz;
}

/* SculpteoViewerControl */
(function ($) {
  var internal = {
    getControlledViewer: function (el) {
      var p = $(el).closest(".SculpteoViewerControl");

      return p.data("controlled-viewer");
    },

    getControlledInternalViewer: function (el) {
      return $(internal.getControlledViewer(el)).Sculpteo3DViewer("viewer");
    },
  };

  var methods = {
    init: function (sculpteo3DViewer, options) {
      return this.each(function () {
        var $this = $(this);
        var data = $(this).data("controlled-viewer");

        if (!data) {
          $this.addClass("SculpteoViewerControl");
          sculpteo3DViewer.data("control", $this);

          // Make sure control is always visible, we need it to change technology
          // if viewer init fails
          $this.show();

          $(".rotate-x", $this).click(function (evt) {
            internal
              .getControlledViewer($this)
              .Sculpteo3DViewer({ rotateX90: true });
          });

          $(".rotate-y", $this).click(function (evt) {
            internal
              .getControlledViewer($this)
              .Sculpteo3DViewer({ rotateY90: true });
          });

          $(".rotate-z", $this).click(function (evt) {
            internal
              .getControlledViewer($this)
              .Sculpteo3DViewer({ rotateZ90: true });
          });

          $(".auto-rotate", $this).click(function (evt) {
            internal
              .getControlledViewer($this)
              .Sculpteo3DViewer({ toggleAutorotate: true });
          });

          $(".reset", $this).click(function (evt) {
            internal
              .getControlledViewer($this)
              .Sculpteo3DViewer({ resetview: true });
          });

          $(".viewer-snapshot", $this).click(function (evt) {
            if ($(this).hasClass("disabled")) {
              return false;
            }

            var viewer = internal.getControlledInternalViewer(this);

            if (viewer) {
              var url = viewer.getSnapshotUrl(1024, 1024, 2);

              // Avoid cache on the render url
              url = url.replace(URLS["render"], URLS["render_snapshot"]);
              var button = $(this);

              $(this).addClass("disabled");
              $(".loader", $(this)).show();
              Utils.setCookie("sculpteo-render", "inprogress", 0, "/");
              url += "&screenshot=1";

              if (
                typeof viewerUI != "undefined" &&
                !$.isEmptyObject(viewerUI.solidity_check_labels)
              ) {
                url += "&thicknessCheck=1";
              }

              $("iframe", $(this)).attr("src", url);
              (function loop() {
                setTimeout(function () {
                  if (Utils.getCookie("sculpteo-render") != null) {
                    loop();
                  } else {
                    button.removeClass("disabled");
                    $(".loader", button).hide();
                  }
                }, 1000);
              })();

              return false;
            }
          });

          // Attach event to wireframe mode
          $(".wireframe", $this).click(function (evt) {
            var viewer = internal.getControlledViewer($this);

            $(this).toggleClass("on");
            viewer.Sculpteo3DViewer({ wireframe: $(this).is(".on") });
          });

          if (options && options.url_embed_uuid) {
            $(".viewer-fullscreen", $this).attr("href", options.url_embed_uuid);
          } else {
            $(".viewer-fullscreen", $this).hide();
          }

          if (options && options.url_design_uuid) {
            $(".viewer-logo", $this).click(function (evt) {
              parent.window.location = options.url_design_uuid;
            });
          } else {
            $(".viewer-logo", $this).hide();
          }

          if (options && options.urls && options.urls["order"]) {
            $(".viewer-basket", $this).click(function (evt) {
              parent.window.location = options.urls["order"];
            });
          } else {
            $(".viewer-basket", $this).hide();
          }

          if (
            history.length > 1 &&
            (self == parent ||
              !self.name ||
              parent.frames[self.name].location.href != document.location.href)
          ) {
            $(".viewer-back", $this)
              .show()
              .click(function (evt) {
                history.go(-1);

                return false;
              });
          }

          /* Create and attach event to the bg color slider in the remote control */
          if (options && $(".bgcolor-slider", $this).slider) {
            $(".bgcolor-slider", $this).slider({
              value: options.bgcolor,
              min: 0,
              max: 255,
              step: 1,
              slide: function (evt, ui) {
                internal.getControlledViewer($this).Sculpteo3DViewer({
                  bgcolor: [ui.value, ui.value, ui.value],
                });

                if ($.Topic) {
                  $.Topic("viewer-background-color-changed").publish([
                    ui.value,
                    ui.value,
                    ui.value,
                  ]);
                }
              },
            });
          }
        }

        $this.data("controlled-viewer", sculpteo3DViewer);
      });
    },

    color: function (grey) {
      return this.each(function () {
        $(".bgcolor-slider", $(this)).slider("value", grey);
        internal
          .getControlledViewer($(this))
          .Sculpteo3DViewer({ bgcolor: [grey, grey, grey] });
      });
    },
  };

  $.fn.SculpteoViewerControl = function (method) {
    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "Method " + method + " does not exist on jQuery.SculpteoViewerControl"
      );
    }
  };
})(jQuery); /* SculpteoViewerControl */
